(function () {
  'use strict';

  // Safari "Alle Cookies blockieren" (und manche In-App-WebViews) werfen
  // bereits beim ZUGRIFF auf window.localStorage eine SecurityError — ein
  // einziger ungeschützter Zugriff killt das ganze Script und lässt die
  // Seite tot zurück. Fallback auf einen In-Memory-Store, damit die App
  // innerhalb der Sitzung weiter funktioniert.
  var localStore = (function () {
    try {
      var s = window.localStorage;
      s.setItem('__tt_probe', '1'); s.removeItem('__tt_probe');
      return s;
    } catch (e) {
      var mem = {};
      return {
        getItem: function (k) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
        setItem: function (k, v) { mem[k] = String(v); },
        removeItem: function (k) { delete mem[k]; }
      };
    }
  })();

  var TT_LOCALE = (function () {
    try {
      var html = document.documentElement.lang;
      if (html) {
        if (/^de\b/i.test(html)) return 'de-CH';
        if (/^fr\b/i.test(html)) return 'fr-CH';
        if (/^it\b/i.test(html)) return 'it-CH';
        if (/^en\b/i.test(html)) return 'en-CH';
        return html;
      }
    } catch (e) {}
    return 'de-CH';
  })();
  var T = window.TT_I18N || { t: function (k) { return k; }, common: {}, selector: {}, abo: {}, cockpit: {}, streak: {}, timeline: {}, line: {}, nutri: {}, diet: {}, cart: {}, validation: {} };

  // ============================================================
  // CONFIG
  // ============================================================

  var API_BASE = 'https://api.loopsubscriptions.com/storefront/2023-10';
  var SHOP_DOMAIN = 'tom-tasty.myshopify.com';
  var BUNDLE_NAME = 'Tom Tasty Abo Live';
  var BUNDLE_NANO_ID = '9f2bc0536b894f3386cf8a25b4b5dee0';
  // Keep in-app redirects in the visitor's language (DE has no prefix, EN/FR
  // are served under /en and /fr) so logged-out EN/FR users are not bounced to
  // the German page. Prefer Shopify's locale-aware root; fall back to the
  // locale segment already present in the current URL.
  function ttLocaleRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r && r !== '/') return '/' + r.replace(/^\/+|\/+$/g, '');
    } catch (e) {}
    var m = (window.location.pathname || '').match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/)/i);
    return m ? '/' + m[1].toLowerCase() : '';
  }
  function localized(p) {
    if (!p || p.charAt(0) !== '/' || p.charAt(1) === '/') return p;
    return ttLocaleRoot() + p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
  }
  var COCKPIT_PATH = localized('/pages/cockpit');
  var LOGIN_PATH = localized('/pages/login');

  var STORAGE = {
    accessToken: 'loopAccessToken',
    refreshToken: 'loopRefreshToken',
  };

  // ============================================================
  // DOM
  // ============================================================

  var root = document.getElementById('tt-selector');
  if (!root) return;

  var elLoading = document.getElementById('tt-sel-loading');
  var elContent = document.getElementById('tt-sel-content');
  var elError = document.getElementById('tt-sel-error');
  var elToast = document.getElementById('tt-sel-toast');

  // ============================================================
  // STATE
  // ============================================================

  var state = {
    customer: null,
    subscription: null,
    bundleConfig: null,       // Bundle configuration from Loop (products, boxSizes, discounts)
    bundleTransaction: null,  // Existing bundle transaction (if any)
    bundleTransactionId: null,
    selections: {},           // variantShopifyId -> { quantity, product info }
    saving: false,
    dirty: false,
    activeFilter: 'ausgewogen',  // 'ausgewogen' | 'sport' | 'abnehmen'
  };

  // ============================================================
  // TOKEN MANAGEMENT
  // ============================================================

  function isTokenValid(token) {
    if (!token || token === 'undefined') return false;
    try {
      var payload = JSON.parse(atob(token.split('.')[1]));
      return !(payload.exp && payload.exp * 1000 < Date.now());
    } catch (e) {
      return false;
    }
  }

  function clearTokens() {
    localStore.removeItem(STORAGE.accessToken);
    localStore.removeItem(STORAGE.refreshToken);
    localStore.removeItem('loop_portal_access_token');
    localStore.removeItem('loop_portal_refresh_token');
    localStore.removeItem('loop_portal_token_expiry');
  }

  async function getValidToken() {
    var access = localStore.getItem(STORAGE.accessToken);
    if (isTokenValid(access)) return access;

    var refresh = localStore.getItem(STORAGE.refreshToken);
    if (refresh) {
      try {
        var res = await fetch(API_BASE + '/auth/accessToken', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken: refresh }),
        });
        if (res.ok) {
          var data = await res.json();
          if (data.data && data.data.accessToken) {
            localStore.setItem(STORAGE.accessToken, data.data.accessToken);
            return data.data.accessToken;
          }
        }
      } catch (e) { /* refresh failed */ }
    }
    return null;
  }

  // ============================================================
  // API
  // ============================================================

  async function apiFetch(endpoint, opts) {
    var token = await getValidToken();
    if (!token) return null;

    var config = {
      method: (opts && opts.method) || 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
    };
    if (opts && opts.body) config.body = JSON.stringify(opts.body);

    var res = await fetch(API_BASE + endpoint, config);
    if (res.status === 401) { clearTokens(); goToLogin(); return null; }

    var data;
    try { data = await res.json(); } catch (e) { data = null; }

    if (!res.ok) {
      var errMsg = (data && data.message) || ('API ' + res.status);
      console.error('Loop API error:', endpoint, res.status, data);
      throw new Error(errMsg);
    }

    return data ? (data.data !== undefined ? data.data : data) : null;
  }

  function goToLogin() {
    window.location.href = LOGIN_PATH;
  }

  // Extract bundle transaction nanoId from subscription line item properties.
  // Loop stores it under the `_bundleId` line-item property (Shopify-style).
  // Returns the first match (all bundle lines share the same id).
  function findBundleIdFromLines(lines) {
    if (!lines || !lines.length) return null;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!line) continue;
      if (line._bundleId) return line._bundleId;
      if (line.bundleId) return line.bundleId;
      var props = line.properties || line.customAttributes || line.lineItemProperties || line.attributes;
      if (Array.isArray(props)) {
        for (var j = 0; j < props.length; j++) {
          var p = props[j] || {};
          var name = p.name || p.key;
          if (name === '_bundleId' || name === 'bundleId') return p.value;
        }
      } else if (props && typeof props === 'object') {
        if (props._bundleId) return props._bundleId;
        if (props.bundleId) return props.bundleId;
      }
    }
    return null;
  }

  // ============================================================
  // HELPERS
  // ============================================================

  function esc(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  // Parse Tom Tasty nutrition data from the Shopify product description.
  // Real-world format (per 100g), German / English / French labels — the
  // description arrives in the storefront language via the locale-aware
  // /products/<handle>.json fetch:
  //   "Portion: 450g"                          "Portion : 450g"
  //   "Energie: 764 kJ / 183 kcal"             "Énergie : 506 kJ / 121 kcal"
  //   "Fett: 9.0 g" / "Fat: 4.2 g"             "Matières grasses : 4.2 g"
  //   "Kohlenhydrate: 6.7 g" / "Carbohydrates" "Glucides : 15.7 g"
  //   "Protein: 16.1 g"                        "Protéines : 4.0 g"
  // Also tolerates the short pipe format "Kcal: 570 | Prot: 46g | Carb: 38g | Fett: 25g".
  // When a portion is present, values are scaled to the portion so the
  // numbers shown match what the customer actually eats.
  function parseNutrition(text) {
    if (!text) return null;
    var s = String(text).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ');
    var grabNum = function (re) {
      var m = s.match(re);
      return m ? parseFloat(m[1].replace(',', '.')) : null;
    };
    // Energy: prefer the explicit "<num> kcal" sequence to avoid matching the
    // kJ number that often precedes it ("764 kJ / 183 kcal").
    var kcal = grabNum(/([0-9]+(?:[.,][0-9]+)?)\s*kcal/i);
    var prot = grabNum(/(?:^|[^a-zà-ÿ])(?:proteine?s?|prot[eé]ines?|prot|eiwei(?:ss|ß))(?![a-zà-ÿ])\s*:?\s*([0-9]+(?:[.,][0-9]+)?)/i);
    var carb = grabNum(/(?:^|[^a-zà-ÿ])(?:kohlenhydrate?n?|carbohydrates?|carbs?|kh|glucides?)(?![a-zà-ÿ])\s*:?\s*([0-9]+(?:[.,][0-9]+)?)/i);
    // The trailing lookahead keeps "Fettsäuren"/"fatty acids" (saturated fats)
    // from matching; only the bare label counts.
    var fat  = grabNum(/(?:^|[^a-zà-ÿ])(?:fett|fat|lipides?|mati[eè]res\s+grasses)(?![a-zà-ÿ])[^0-9-]*([0-9]+(?:[.,][0-9]+)?)/i);
    if (kcal == null && prot == null && carb == null && fat == null) return null;

    // Detect "per 100g" + Portion to rescale.
    var portionG = null;
    var portionMatch = s.match(/portion[^0-9]*([0-9]+(?:[.,][0-9]+)?)\s*g/i);
    if (portionMatch) portionG = parseFloat(portionMatch[1].replace(',', '.'));
    var isPer100 = /pro\s*100\s*g|per\s*100\s*g|pour\s*100\s*g/i.test(s);

    var scale = (isPer100 && portionG) ? (portionG / 100) : 1;
    var round = function (v, d) { return v == null ? null : Math.round(v * Math.pow(10, d || 0)) / Math.pow(10, d || 0); };
    return {
      kcal: round(kcal != null ? kcal * scale : null, 0),
      prot: round(prot != null ? prot * scale : null, 1),
      carb: round(carb != null ? carb * scale : null, 1),
      fat:  round(fat  != null ? fat  * scale : null, 1),
      portionG: portionG
    };
  }

  function renderNutritionChips(n, opts) {
    if (!n) return '';
    var compact = opts && opts.compact;
    var cls = 'tt-sel__nutri' + (compact ? ' tt-sel__nutri--compact' : '');
    var cell = function (label, value, unit) {
      if (value == null) return '';
      var v = Number.isInteger(value) ? value : (Math.round(value * 10) / 10);
      return '<span class="tt-sel__nutri-cell"><em>' + label + '</em><b>' + v + (unit || '') + '</b></span>';
    };
    return '<div class="' + cls + '">'
      + cell((T.nutri && T.nutri.kcal) || 'Kcal', n.kcal, '')
      + cell((T.nutri && T.nutri.prot) || 'Prot', n.prot, 'g')
      + cell((T.nutri && T.nutri.carb) || 'Carb', n.carb, 'g')
      + cell((T.nutri && T.nutri.fat) || 'Fett', n.fat, 'g')
      + '</div>';
  }

  function formatDateShort(dateStr) {
    if (!dateStr) return '';
    var d = new Date(dateStr);
    return d.toLocaleDateString(TT_LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function fmtDayLong(d) {
    if (!(d instanceof Date) || isNaN(d)) return '';
    return d.toLocaleDateString(TT_LOCALE, { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function fmtCutoffShort(d) {
    if (!(d instanceof Date) || isNaN(d)) return '';
    return d.toLocaleDateString(TT_LOCALE, { weekday: 'short', day: '2-digit', month: '2-digit' });
  }

  // Friday billing date → { deadline (Friday 11:00), delivery (Wednesday +5d) }.
  // Auto-advances stale data: if the deadline is more than 1h past, roll both
  // forward by 7-day steps until the deadline is in the future again.
  function getDeadlineAndDelivery(nextBillingDate) {
    if (!nextBillingDate) return { deadline: null, delivery: null };
    var deadline = new Date(nextBillingDate);
    var graceMs = 60 * 60 * 1000;
    for (var i = 0; i < 52; i++) {
      var d11 = new Date(deadline); d11.setHours(11, 0, 0, 0);
      if ((Date.now() - d11) <= graceMs) break;
      deadline.setDate(deadline.getDate() + 7);
    }
    var delivery = new Date(deadline);
    delivery.setDate(delivery.getDate() + 5);
    return { deadline: deadline, delivery: delivery };
  }

  function hoursUntil(target) {
    if (!(target instanceof Date)) return null;
    var t = new Date(target); t.setHours(11, 0, 0, 0);
    var ms = t - new Date();
    return ms > 0 ? Math.round(ms / 3600000) : 0;
  }

  // ISO 8601 calendar week (KW) — same definition Switzerland/Germany use.
  function isoWeekNumber(date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  }

  function getSubIdFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('sub');
  }

  function showView(view) {
    elLoading.style.display = view === 'loading' ? '' : 'none';
    elContent.style.display = view === 'content' ? '' : 'none';
    elError.style.display = view === 'error' ? '' : 'none';
  }

  function showToast(msg, isError) {
    elToast.textContent = msg;
    elToast.className = 'tt-sel__toast tt-sel__toast--visible' + (isError ? ' tt-sel__toast--error' : '');
    setTimeout(function () {
      elToast.className = 'tt-sel__toast';
    }, 3000);
  }

  // Full-screen spinner shown the instant "Speichern" is clicked. The Loop
  // bundle/subscription update can take a few seconds, so we cover the page
  // immediately instead of only swapping the button label.
  function showSavingOverlay() {
    var el = document.getElementById('tt-sel-saving');
    if (el) el.hidden = false;
  }
  function hideSavingOverlay() {
    var el = document.getElementById('tt-sel-saving');
    if (el) el.hidden = true;
  }

  // Hygiene: the pre-relaunch selector (Loop's bundle widget) left orphaned
  // "loop-bundle-*" localStorage keys behind on customer devices. Nothing
  // reads them anymore, but they confuse debugging (and analyses) — sweep
  // them once per visit. Guarded: key iteration needs the real storage.
  function cleanupLegacyBundleKeys() {
    try {
      for (var i = window.localStorage.length - 1; i >= 0; i--) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf('loop-bundle-') === 0) window.localStorage.removeItem(k);
      }
    } catch (e) { /* storage blocked — nothing to clean anyway */ }
  }

  // ============================================================
  // INIT — NEW ARCHITECTURE
  // 1. Load bundle config from Loop (products come from here, not Shopify collection)
  // 2. Load subscription to find existing bundle transaction
  // 3. If transaction exists → load current selections
  // 4. If not → start fresh (create on first save)
  // ============================================================

  async function init() {
    showView('loading');
    cleanupLegacyBundleKeys();

    var token = await getValidToken();
    if (!token) {
      goToLogin();
      return;
    }

    try {
      // Load bundles list, customer, and subscriptions in parallel
      var results = await Promise.all([
        apiFetch('/bundle?myshopifyDomain=' + SHOP_DOMAIN),
        apiFetch('/customer/'),
        apiFetch('/subscription'),
      ]);

      var allBundles = results[0];
      state.customer = results[1];
      var subs = results[2];

      // allBundles is an array — find our bundle by name
      var bundleSummary = null;
      if (Array.isArray(allBundles)) {
        bundleSummary = allBundles.find(function (b) { return b.name === BUNDLE_NAME; }) || allBundles[0];
      } else if (allBundles && allBundles.id) {
        bundleSummary = allBundles;
      }

      if (!bundleSummary || !bundleSummary.id) {
        throw new Error('Bundle "' + BUNDLE_NAME + '" nicht gefunden.');
      }

      var BUNDLE_API_ID = bundleSummary.id;
      console.log('Found bundle:', BUNDLE_API_ID, bundleSummary.name);

      // Now fetch full bundle config with the correct API ID
      try {
        var fullBundle = await apiFetch('/bundle/' + BUNDLE_API_ID + '?myshopifyDomain=' + SHOP_DOMAIN);
        state.bundleConfig = fullBundle;
      } catch (e) {
        console.warn('Full bundle fetch failed, using summary:', e.message);
        // The list endpoint might already return enough data (products, boxSizes, etc.)
        state.bundleConfig = bundleSummary;
      }

      // Store the API bundle ID for create transaction calls
      state.bundleApiId = BUNDLE_API_ID;

      console.log('Bundle config loaded:', (state.bundleConfig.products || []).length, 'products');

      // Normalize subscriptions array
      if (subs && !Array.isArray(subs)) subs = subs.subscriptions || [];

      // Sort newest-first so that any pick-by-status below resolves to the
      // most recently created subscription. Loop's list endpoint doesn't
      // guarantee ordering, and customers occasionally end up with duplicate
      // subs (e.g. checkout flow created two) — we always want to land on
      // the freshest one. Mirrors the cockpit's selection logic.
      subs.sort(function (a, b) {
        var da = new Date(a.createdAt || a.nextBillingDate || 0);
        var db = new Date(b.createdAt || b.nextBillingDate || 0);
        return db - da;
      });

      // Find the requested subscription
      var subId = getSubIdFromUrl();
      var sub = null;
      if (subId) {
        sub = subs.find(function (s) { return s.id === subId; });
      }
      if (!sub) {
        sub = subs.find(function (s) { return s.status === 'ACTIVE'; })
          || subs.find(function (s) { return s.status === 'PAUSED'; })
          || subs[0];
      }

      if (!sub) {
        showView('error');
        document.getElementById('tt-sel-error-msg').textContent = 'Kein aktives Abonnement gefunden.';
        return;
      }

      // Fetch full subscription details (list endpoint may not include lines)
      try {
        var subDetail = await apiFetch('/subscription/' + sub.id);
        if (subDetail) sub = subDetail;
      } catch (e) {
        console.warn('Could not fetch subscription detail, using list data:', e.message);
      }

      state.subscription = sub;
      console.log('Subscription lines:', JSON.stringify(sub.lines));

      // If bundle config failed, show error but don't crash
      if (!state.bundleConfig) {
        showView('error');
        document.getElementById('tt-sel-error-msg').textContent = 'Bundle-Konfiguration konnte nicht geladen werden.';
        return;
      }

      // Find bundle transaction nanoId from line properties (_bundleId).
      // Loop's API expects the string nanoId (e.g. "01HM6YF4YG..."), NOT the numeric bundleTransactionId.
      // Docs: https://developer.loopwork.co/docs/sell-and-edit-byob-using-storefront-bundle-apis
      var btNanoId = findBundleIdFromLines(sub.lines);
      var btNumericId = null;
      if (sub.lines && sub.lines.length) {
        for (var i = 0; i < sub.lines.length; i++) {
          if (sub.lines[i].bundleTransactionId) {
            btNumericId = sub.lines[i].bundleTransactionId;
            break;
          }
        }
      }
      console.log('Bundle transaction IDs — nanoId (_bundleId):', btNanoId, 'numeric:', btNumericId);

      // Try to load existing bundle transaction via nanoId (correct per Loop docs)
      var btLoaded = false;
      if (btNanoId) {
        try {
          var btData = await apiFetch('/bundle/transaction/' + btNanoId);
          if (btData && btData.items) {
            state.bundleTransaction = btData;
            state.bundleTransactionId = btNanoId;
            buildSelectionsFromBundleItems(btData.items);
            btLoaded = true;
          }
        } catch (e) {
          console.warn('Bundle transaction not found for nanoId', btNanoId, '-', e.message);
        }
      }
      // Legacy fallback: try numeric id (older subs may not expose _bundleId property)
      if (!btLoaded && btNumericId) {
        try {
          var btData2 = await apiFetch('/bundle/transaction/' + btNumericId);
          if (btData2 && btData2.items) {
            state.bundleTransaction = btData2;
            state.bundleTransactionId = btNumericId;
            buildSelectionsFromBundleItems(btData2.items);
            btLoaded = true;
          }
        } catch (e) {
          console.warn('Bundle transaction not found for numeric id', btNumericId, '-', e.message);
        }
      }
      state.bundleNanoId = btNanoId;
      state.bundleNumericId = btNumericId;

      // Fallback: pre-select from subscription lines (current subscription products)
      if (!btLoaded && sub.lines && sub.lines.length > 0) {
        var bundleProducts = getBundleProducts();
        var fallbackBundleVariantSet = getBundleVariantIdSet();
        sub.lines.forEach(function (line) {
          // Loop uses variantShopifyId and productShopifyId
          var vid = String(line.variantShopifyId || line.variantId || '');
          if (!vid) return;
          // Skip Loop-managed addons (free gifts, one-time addons) — same
          // rationale as buildSelectionsFromBundleItems.
          if (fallbackBundleVariantSet && !fallbackBundleVariantSet[vid]) {
            try { console.log('[tt-selector] skipping non-bundle line (likely Loop addon):', vid, line.productTitle || line.name); } catch (e) {}
            return;
          }
          // Match with bundle product for display info
          var bProd = bundleProducts.find(function (p) {
            return String(p.variantId) === vid;
          });
          if (bProd) {
            state.selections[vid] = {
              quantity: line.quantity || 1,
              variantId: vid,
              productId: bProd.id,
              productTitle: bProd.title,
              variantTitle: bProd.variantTitle,
              price: bProd.price,
              image: bProd.image,
            };
          } else {
            state.selections[vid] = {
              quantity: line.quantity || 1,
              variantId: vid,
              productId: String(line.productShopifyId || ''),
              productTitle: line.productTitle || line.name || 'Gericht',
              variantTitle: line.variantTitle || '',
              price: parseFloat(line.price || line.discountedPrice || 0),
              image: null,
            };
          }
        });
        console.log('Pre-selected from lines:', Object.keys(state.selections).length, 'items');
      }

      showView('content');
      render();

      // Load Shopify product data (description, tags) in background for badge matching
      loadShopifyProductData();

    } catch (err) {
      console.error('Selector init error:', err);
      showView('error');
      document.getElementById('tt-sel-error-msg').textContent = err.message || 'Fehler beim Laden.';
    }
  }

  // ============================================================
  // BUNDLE CONFIG HELPERS
  // ============================================================

  // Set of every variantId that belongs to the BYOB bundle (regardless of
  // active/in-stock status — we want the historical universe, not just what's
  // currently sellable). Anything outside this set in a bundle transaction is
  // a Loop-managed addon (free gift, one-time addon, etc.) that we must NOT
  // echo back to /bundle/transaction/update — otherwise Loop's addon
  // bookkeeping breaks and the next reconciliation fires a duplicate update.
  function getBundleVariantIdSet() {
    var bc = state.bundleConfig;
    if (!bc || !bc.products) return null;
    var set = Object.create(null);
    bc.products.forEach(function (p) {
      if (!p.variants) return;
      p.variants.forEach(function (v) {
        if (v && v.shopifyId != null) set[String(v.shopifyId)] = true;
      });
    });
    return set;
  }

  // Get available products from bundle config (replaces Shopify collection)
  function getBundleProducts() {
    var bc = state.bundleConfig;
    if (!bc || !bc.products) return [];

    var products = [];
    var loggedSample = false;
    bc.products.forEach(function (p) {
      if (p.status && p.status.toLowerCase() !== 'active') return;
      if (!p.variants || !p.variants.length) return;

      // One-time debug: log the raw shape of the first product so we can
      // identify the actual field that holds the nutrition short description.
      if (!loggedSample) {
        try { console.log('[tt-selector] bundle product sample:', p); } catch (e) {}
        loggedSample = true;
      }

      // Probe every plausible Loop / Shopify field name for the nutrition
      // short description. The first non-empty match wins.
      var shortDesc = p.shortDescription
        || p.short_description
        || p.subtitle
        || p.summary
        || p.excerpt
        || p.descriptionHtml
        || (p.metafields && (p.metafields.short_description || p.metafields.shortDescription || p.metafields.subtitle))
        || '';

      var extra = shopifyProductData[p.handle] || {};

      p.variants.forEach(function (v) {
        if (v.outOfStock) return;
        products.push({
          id: p.shopifyId,
          shopifyProductId: p.shopifyId,
          variantId: v.shopifyId,
          title: displayDishTitle(p.title, extra.title),
          handle: p.handle,
          variantTitle: v.title,
          price: parseFloat(v.price || 0),
          image: v.imageURL || null,
          categoryId: p.categoryId || null,
          available: !v.outOfStock,
          shortDescription: shortDesc,
        });
      });
    });

    return products;
  }

  // Get the default box size from bundle config
  function getDefaultBoxSize() {
    var bc = state.bundleConfig;
    if (!bc || !bc.boxSizes || !bc.boxSizes.length) return null;
    var def = bc.boxSizes.find(function (bs) { return bs.defaultSelected; });
    return def || bc.boxSizes[0];
  }

  // Helper: get min quantity from a discount (storefront API uses minCartQuantity, bundle page uses minConditionValue)
  function getDiscountMinQty(d) {
    return d.minCartQuantity || d.minConditionValue || 0;
  }

  // Find applicable discount based on total quantity
  function findApplicableDiscount(totalQty) {
    var bc = state.bundleConfig;
    if (!bc || !bc.discounts || !bc.discounts.length) return null;

    var eligible = bc.discounts
      .filter(function (d) {
        return (d.purchaseType === 'SUBSCRIPTION' || d.purchaseType === 'ALL')
          && d.conditionType === 'QUANTITY'
          && totalQty >= getDiscountMinQty(d);
      })
      .sort(function (a, b) { return getDiscountMinQty(b) - getDiscountMinQty(a); });

    return eligible.length ? eligible[0] : null;
  }

  // Combined discount factor for the cart's current state: bundle qty tier
  // + non-LPBNDL subscription coupons applied sequentially. Returns 1 when
  // nothing applies. Used both by the cart bar summary and to strike
  // through individual dish prices.
  function getCurrentDiscountFactor() {
    var totalQty = 0;
    Object.keys(state.selections).forEach(function (k) { totalQty += state.selections[k].quantity || 0; });
    var tiers = getDiscountTiers();
    var tier = null;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (totalQty >= tiers[i].qty) { tier = tiers[i]; break; }
    }
    var factor = 1;
    if (tier && tier.pct > 0) factor *= (1 - tier.pct / 100);
    var subDiscounts = (state.subscription && state.subscription.discounts) || [];
    subDiscounts.forEach(function (d) {
      var code = d.code || d.title || '';
      if (/^LPBNDL/i.test(code)) return;
      var pct = (d.value && d.value.percentage) ? parseFloat(d.value.percentage) : 0;
      if (pct > 0) factor *= (1 - pct / 100);
    });
    return factor;
  }

  // Return all QUANTITY-based subscription tiers sorted by minQty asc.
  function getDiscountTiers() {
    var bc = state.bundleConfig;
    if (!bc || !bc.discounts) return [];
    return bc.discounts
      .filter(function (d) {
        return (d.purchaseType === 'SUBSCRIPTION' || d.purchaseType === 'ALL')
          && d.conditionType === 'QUANTITY' && getDiscountMinQty(d) > 0;
      })
      .map(function (d) {
        var pct = parseFloat(d.discountValue || d.value || 0);
        return { qty: getDiscountMinQty(d), pct: pct };
      })
      .sort(function (a, b) { return a.qty - b.qty; });
  }

  // Get categories from bundle config
  // Preferred display order for known categories. Anything not listed keeps
  // its Loop-order position relative to other unlisted entries — except
  // Frühstück, which always sits at the very bottom.
  var CATEGORY_ORDER = ['fleisch & fisch', 'fleisch und fisch', 'vegetarisch', 'sharing', 'suppe', 'suppen'];
  function categoryRank(title) {
    if (isBreakfastCategory(title)) return CATEGORY_ORDER.length + 1;
    var i = CATEGORY_ORDER.indexOf(String(title || '').toLowerCase());
    return i === -1 ? CATEGORY_ORDER.length : i;
  }

  // Cosmetic relabels — Loop's category title stays canonical, we only change
  // what the customer sees. Only a fallback for categories without a
  // registered tt.category translation.
  var CATEGORY_LABELS = {
    'vegetarisch': 'Vegetarisch & Vegan'
  };
  // Map a Loop category title (e.g. "Fleisch & Fisch", "Frühstück") to a
  // locale key ("fleisch_fisch", "fruhstuck") so the tabs read in the
  // visitor's language on EN/FR. Umlauts/accents are transliterated so the
  // key stays ASCII. Shopify's `t` filter HTML-encodes & → &amp;, so decode
  // before returning — callers still pass the result through esc().
  function categoryKey(s) {
    return String(s || '').toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u')
      .replace(/[éèê]/g, 'e')
      .replace(/[^a-z0-9]+/g, '_').replace(/(^_|_$)/g, '');
  }
  function decodeHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.innerHTML = String(s);
    return d.textContent || '';
  }
  function displayCategoryTitle(title) {
    if (!title) return '';
    var key = categoryKey(title);
    if (T.category && T.category[key]) return decodeHtml(T.category[key]);
    return CATEGORY_LABELS[String(title).toLowerCase()] || title;
  }
  // Loop's bundle-config subtitle text is German-only (see note above
  // shopifyProductData). Translate it the same way as the category title —
  // fall back to the raw Loop text when no tt.category_subtitle entry is
  // registered for this category, so untouched categories render exactly
  // as before.
  function displayCategorySubtitle(title, subTitle) {
    var key = categoryKey(title);
    if (T.category_subtitle && T.category_subtitle[key]) return decodeHtml(T.category_subtitle[key]);
    return subTitle;
  }
  function getCategories() {
    var bc = state.bundleConfig;
    var cats = (bc && bc.categories) ? bc.categories.slice() : [];
    cats.sort(function (a, b) {
      return categoryRank(a.title) - categoryRank(b.title);
    });
    return cats;
  }

  // ============================================================
  // CUSTOMER PROFILE — from onboarding localStorage + Shopify API
  // ============================================================

  var customerProfile = {
    target: [],
    form: [],
    like: [],
    dislike: [],
    conditions: [],
    hasProfile: false,
  };

  // Extra product data from Shopify (title, description, tags) — loaded async
  // via the locale-aware /products/<handle>.json endpoint, so on EN/FR the
  // content arrives translated (Loop's bundle config is German-only).
  var shopifyProductData = {};
  // variantShopifyId → locale-aware display title. Filled after
  // loadShopifyProductData so cart rows (whose selections snapshot the German
  // Loop title early) can still render the translated name.
  var dishTitleByVid = {};

  // Prefer the Shopify (translated) product title on EN/FR. The emoji line
  // markers (⚖️/💪/🔥) drive the line filter, so carry a marker over if the
  // translation dropped it. On DE (no locale prefix) the fetch returns the
  // German title anyway — keep Loop's title untouched to avoid any diff.
  var HAS_LOCALE_PREFIX = ttLocaleRoot() !== '';
  var LINE_MARKERS = ['⚖️', '💪', '🔥'];
  function displayDishTitle(loopTitle, shopifyTitle) {
    if (!HAS_LOCALE_PREFIX || !shopifyTitle) return loopTitle;
    var out = shopifyTitle;
    LINE_MARKERS.forEach(function (m) {
      var probe = m.charAt(0) === '⚖' ? '⚖' : m;
      if ((loopTitle || '').indexOf(probe) !== -1 && out.indexOf(probe) === -1) out += ' ' + m;
    });
    return out;
  }

  // Onboarding profile deprecated — line selection happens via the top-right
  // selector on the order page. customerProfile stays empty so all
  // diet-violation rendering paths bail out.

  function getProfileFilter() {
    if (!customerProfile.hasProfile || !customerProfile.target.length) return null;
    var t = customerProfile.target[0].toLowerCase();
    if (t.indexOf('sport') !== -1) return 'sport';
    if (t.indexOf('abnehm') !== -1 || t.indexOf('erkrank') !== -1) return 'abnehmen';
    return 'ausgewogen';
  }

  // Restore previously chosen line from localStorage so the user's selection
  // sticks between visits without needing onboarding.
  (function () {
    try {
      var saved = localStore.getItem('tt_selector_line');
      if (saved === 'ausgewogen' || saved === 'sport' || saved === 'abnehmen') {
        state.activeFilter = saved;
      }
    } catch (e) {}
  })();

  function ttDayShort(d) {
    try { return new Intl.DateTimeFormat(TT_LOCALE, { weekday: 'short' }).format(d).replace(/\.$/, ''); }
    catch (e) { return ['So','Mo','Di','Mi','Do','Fr','Sa'][d.getDay()]; }
  }
  // ── Emoji filter helpers ──

  function hasEmojiMarker(title) {
    return /[\u2696\uFE0F\uD83D\uDCAA\uD83D\uDD25]/.test(title);
  }

  function isAlwaysVisibleCategory(catTitle) {
    if (!catTitle) return false;
    var lower = catTitle.toLowerCase();
    return lower.indexOf('suppe') !== -1 || lower.indexOf('sharing') !== -1;
  }

  // Breakfast category — gets the muesli serving note under its title.
  function isBreakfastCategory(catTitle) {
    if (!catTitle) return false;
    var lower = catTitle.toLowerCase();
    return lower.indexOf('frühstück') !== -1 || lower.indexOf('fruehstueck') !== -1
      || lower.indexOf('breakfast') !== -1 || lower.indexOf('déjeuner') !== -1;
  }

  function getFilterEmoji(f) {
    if (f === 'ausgewogen') return '\u2696\uFE0F';
    if (f === 'sport') return '\uD83D\uDCAA';
    if (f === 'abnehmen') return '\uD83D\uDD25';
    return '';
  }

  function filterProducts(products, categories) {
    var f = state.activeFilter;
    return products.filter(function (p) {
      var cat = categories.find(function (c) { return c.id === p.categoryId; });
      var catTitle = cat ? cat.title : '';
      if (isAlwaysVisibleCategory(catTitle)) return true;
      if (!hasEmojiMarker(p.title)) return true;
      if (f === 'ausgewogen') return p.title.indexOf('\u2696') !== -1;
      if (f === 'sport') return p.title.indexOf('\uD83D\uDCAA') !== -1;
      if (f === 'abnehmen') return p.title.indexOf('\uD83D\uDD25') !== -1;
      return true;
    });
  }

  function getNonRecommendedProducts(products, categories) {
    var f = state.activeFilter;
    return products.filter(function (p) {
      var cat = categories.find(function (c) { return c.id === p.categoryId; });
      var catTitle = cat ? cat.title : '';
      if (isAlwaysVisibleCategory(catTitle)) return false;
      if (!hasEmojiMarker(p.title)) return false;
      if (f === 'ausgewogen') return p.title.indexOf('\u2696') === -1;
      if (f === 'sport') return p.title.indexOf('\uD83D\uDCAA') === -1;
      if (f === 'abnehmen') return p.title.indexOf('\uD83D\uDD25') === -1;
      return false;
    });
  }

  // ── Diet restriction helpers ──

  function hasDietRestriction(key) {
    return customerProfile.form.some(function (f) { return f === key; });
  }

  function isVegan() {
    return customerProfile.form.some(function (f) {
      return f.toLowerCase().indexOf('vegan') !== -1;
    });
  }

  function isVegetarian() {
    return customerProfile.form.some(function (f) {
      var lower = f.toLowerCase();
      return lower.indexOf('vegetar') !== -1 || lower.indexOf('vegan') !== -1;
    });
  }

  function isPescetarian() {
    return customerProfile.form.some(function (f) {
      return f.toLowerCase().indexOf('pescet') !== -1;
    });
  }

  var MEAT_TERMS = [
    'poulet', 'chicken', 'hähnchen', 'hühnchen', 'huhn', 'perlhuhn',
    'ente', 'entenbrust', 'duck',
    'rind', 'beef', 'angus', 'entrecôte', 'entrecote', 'steak',
    'kalb', 'kalbsbratwurst', 'kalbsfond', 'kalbsjus', 'kalbsrücken', 'kalbstafelspitz',
    'schwein', 'pork', 'iberico',
    'lamm',
    'wild', 'hirsch', 'reh', 'wildschwein', 'gitzi',
    'hackfleisch', 'gehacktes', 'ghackets', 'hackbraten', 'burgerfleisch',
    'geschnetzeltes', 'siedfleisch', 'fleisch',
    'wurst', 'bratwurst', 'rauchwurst', 'salsiccia', 'merguez', 'chorizo', 'cervelat',
    'brätler', 'brät',
    'schinken', 'rohschinken', 'prosciutt',
    'salami', 'mortadella',
    'speck', 'pancetta', 'bacon', 'frühstücksspeck', 'bauernspeck',
    'bündnerfleisch', 'mostbröckli', 'bresaola',
    'bolognese', 'gulasch', 'ragout', 'stroganoff', 'saltimbocca',
    'schnitzel', 'cordon bleu', 'gyros', 'kebab', 'döner', 'tatar',
    'cevapcici', 'ćevapčići', 'cevap', 'köfte',
    'pulled pork', 'spare ribs', 'crispy pork', 'char siu',
    'roastbeef', 'leber', 'leberkäse', 'fleischkäs',
    'hühnerbouillon',
  ];
  var FISH_TERMS = [
    'lachs', 'salm', 'salmon', 'rauchlachs', 'räucherlachs', 'lachsforelle', 'gravlax',
    'forelle', 'kabeljau', 'cod', 'dorade', 'goldbrasse',
    'wolfsbarsch', 'branzino', 'zander', 'saibling', 'egli',
    'heilbutt', 'halibut', 'rotbarsch', 'scholle', 'seeteufel',
    'thunfisch', 'tuna', 'sardine', 'sardelle', 'anchovis',
    'kingfisch', 'kingfish', 'pangasius', 'seelachs', 'hering', 'makrele',
    'pulpo', 'oktopus', 'calamar', 'kalamare', 'calamaret', 'tintenfisch',
    'crevette', 'shrimp', 'garnele', 'prawns',
    'jakobsmuschel', 'scallop', 'muschel',
    'hummer', 'lobster', 'languste', 'krebs', 'krabben', 'snow crab',
    'fischfond', 'fischsauce', 'fisch', 'fish',
    'seafood', 'meeresfr', 'surimi', 'kaviar',
    'sushi', 'sashimi',
  ];

  var FALSE_POSITIVES = [
    'erdnussbutter', 'nussbutter', 'mandelbutter', 'cashewbutter',
    'sheabutter', 'kakaobutter', 'kokosbutter',
    'kokosmilch', 'kokosnussmilch', 'hafermilch', 'sojamilch', 'reismilch',
    'mandelmilch', 'cashewmilch', 'pflanzenmilch',
    'kokos-milch', 'hafer-milch', 'soja-milch',
    'kokosrahm', 'haferrahm', 'sojarahm', 'pflanzenrahm', 'sojasahne',
    'kokosnussjoghurt', 'sojajoghurt', 'haferjoghurt', 'kokosjoghurt',
    'veganer käse', 'pflanzenkäse', 'hefeflocken',
    'fleischtomate',
  ];

  function cleanForDietCheck(text) {
    var cleaned = text.toLowerCase();
    var sorted = FALSE_POSITIVES.slice().sort(function (a, b) { return b.length - a.length; });
    sorted.forEach(function (fp) {
      while (cleaned.indexOf(fp) !== -1) {
        cleaned = cleaned.replace(fp, ' ');
      }
    });
    return cleaned;
  }

  function textContainsAny(text, terms) {
    var cleaned = cleanForDietCheck(text);
    return terms.some(function (t) { return cleaned.indexOf(t) !== -1; });
  }

  function isInMeatFishCategory(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    var catLower = catTitle.toLowerCase();
    return catLower.indexOf('fleisch') !== -1 || catLower.indexOf('fisch') !== -1;
  }

  function containsMeat(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    var catLower = catTitle.toLowerCase();
    if (catLower.indexOf('fleisch') !== -1 && catLower.indexOf('fisch') === -1) return true;
    if (product.tags && product.tags.some(function (tag) { return textContainsAny(tag, MEAT_TERMS); })) return true;
    if (textContainsAny(getDominantText(product, 6), MEAT_TERMS)) return true;
    return false;
  }

  function containsFish(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    var catLower = catTitle.toLowerCase();
    if (catLower.indexOf('fisch') !== -1 && catLower.indexOf('fleisch') === -1) return true;
    if (product.tags && product.tags.some(function (tag) { return textContainsAny(tag, FISH_TERMS); })) return true;
    if (textContainsAny(getDominantText(product, 6), FISH_TERMS)) return true;
    return false;
  }

  function isVegetarianProduct(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    var catLower = catTitle.toLowerCase();
    if (catLower.indexOf('vegetar') !== -1 || catLower.indexOf('vegan') !== -1) return true;
    if (product.tags && product.tags.some(function (tag) {
      var l = tag.toLowerCase();
      return l.indexOf('vegetar') !== -1 || l.indexOf('vegan') !== -1;
    })) return true;
    if (isInMeatFishCategory(product, categories)) return false;
    if (containsMeat(product, categories) || containsFish(product, categories)) return false;
    // No meat/fish detected → treat as vegetarian
    return true;
  }

  function isFishProduct(product, categories) {
    return containsFish(product, categories);
  }

  function isPescetarianProduct(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    var catLower = catTitle.toLowerCase();
    if (catLower.indexOf('vegetar') !== -1 || catLower.indexOf('vegan') !== -1) return true;
    if (product.tags && product.tags.some(function (tag) {
      var l = tag.toLowerCase();
      return l.indexOf('vegetar') !== -1 || l.indexOf('vegan') !== -1;
    })) return true;
    if (containsMeat(product, categories)) return false;
    if (isInMeatFishCategory(product, categories)) {
      if (containsFish(product, categories)) return true;
      return false;
    }
    return true;
  }

  function isVeganProduct(product, categories) {
    var cat = categories.find(function (c) { return c.id === product.categoryId; });
    var catTitle = cat ? (cat.title || '') : '';
    if (catTitle.toLowerCase().indexOf('vegan') !== -1) return true;
    if (product.tags && product.tags.some(function (tag) {
      return tag.toLowerCase().indexOf('vegan') !== -1;
    })) return true;
    return false;
  }

  function getDietIcon(product, categories) {
    if (isVeganProduct(product, categories)) return '\uD83C\uDF31';
    if (isVegetarianProduct(product, categories)) return '\uD83E\uDD66';
    return '';
  }

  var GLUTEN_TERMS = ['weizen', 'dinkel', 'roggen', 'gerste', 'hafer', 'mehl', 'paniermehl', 'brot', 'pasta', 'nudel', 'spaghetti', 'penne', 'rigatoni', 'fusilli', 'tagliatelle', 'lasagne', 'couscous', 'bulgur', 'seitan', 'semmel', 'panko', 'tortellini', 'gnocchi', 'farfalle', 'orzo', 'fettuccine', 'linguine', 'ravioli', 'cannelloni', 'pizzateig', 'blätterteig', 'strudelteig', 'knödel', 'spätzle', 'tempura', 'wonton', 'magronen', 'maccaroni'];
  var DAIRY_TERMS = [
    'milch', 'vollmilch', 'buttermilch', 'kondensmilch',
    'butter', 'kräuterbutter',
    'rahm', 'vollrahm', 'doppelrahm', 'halbrahm', 'sauerrahm', 'schlagrahm', 'sahne',
    'creme fraiche', 'crème fraîche',
    'käse', 'bergkäse', 'raclette', 'gruyère', 'gruyere', 'emmentaler', 'appenzeller',
    'tilsiter', 'sbrinz', 'cheddar', 'brie', 'camembert',
    'mozzarella', 'burrata', 'scamorza',
    'parmesan', 'grana padano', 'parmigiano', 'pecorino',
    'ricotta', 'mascarpone', 'gorgonzola', 'feta', 'halloumi', 'paneer',
    'ziegenkäse', 'frischkäse', 'hüttenkäse', 'bratkäse',
    'quark', 'magerquark', 'joghurt', 'yoghurt',
    'labneh', 'labne', 'la cotta',
    'fondue', 'molke', 'laktose', 'schmand',
    'roquefort', 'stilton', 'cottage cheese', 'belper knolle',
  ];

  var EGG_TERMS = [
    'eier', 'eigelb', 'eiklar', 'vollei', 'wachtelei',
    'rührei', 'spiegelei', 'omelette', 'frittata', 'shakshuka',
    'meringue', 'baiser',
    'mayonnaise', 'mayo', 'hollandaise', 'béarnaise',
  ];

  function getFullText(product) {
    var desc = (product.description || '').replace(/<[^>]*>/g, ' ').trim();
    var short = (product.shortDescription || '').replace(/<[^>]*>/g, ' ').trim();
    return (product.title || '') + ' ' + desc + ' ' + short;
  }

  function containsGluten(product, fullScan) {
    var text = (fullScan ? getFullText(product) : getDominantText(product, 6)).toLowerCase();
    var tags = (product.tags || []).map(function (t) { return t.toLowerCase(); }).join(' ');
    return GLUTEN_TERMS.some(function (t) { return (text + ' ' + tags).indexOf(t) !== -1; });
  }

  function containsDairy(product, fullScan) {
    var text = (fullScan ? getFullText(product) : getDominantText(product, 6)).toLowerCase();
    var tags = (product.tags || []).map(function (t) { return t.toLowerCase(); }).join(' ');
    return DAIRY_TERMS.some(function (t) { return (text + ' ' + tags).indexOf(t) !== -1; });
  }

  function containsEggs(product, fullScan) {
    var text = (fullScan ? getFullText(product) : getDominantText(product, 6)).toLowerCase();
    var tags = (product.tags || []).map(function (t) { return t.toLowerCase(); }).join(' ');
    return EGG_TERMS.some(function (t) { return (text + ' ' + tags).indexOf(t) !== -1; });
  }

  function getDietViolations(product, categories) {
    var violations = [];
    var fullText = getFullText(product);

    if (isVegan()) {
      if (isInMeatFishCategory(product, categories)) {
        violations.push(T.diet.contains_fish_meat);
      } else if (containsMeat(product, categories) || containsFish(product, categories)) {
        violations.push(T.diet.contains_fish_meat);
      }
      if (textContainsAny(fullText, DAIRY_TERMS)) {
        violations.push(T.diet.contains_dairy);
      }
      if (textContainsAny(fullText, EGG_TERMS)) {
        violations.push(T.diet.contains_eggs);
      }
    } else if (isVegetarian() && !isVegetarianProduct(product, categories)) {
      violations.push(T.diet.contains_fish_meat);
    } else if (isPescetarian() && !isPescetarianProduct(product, categories)) {
      violations.push(T.diet.contains_meat);
    }
    // Note: Glutenfrei/Laktosefrei were removed from onboarding toggles,
    // but may still exist in old localStorage data — only check if explicitly set
    // and the form value is actually in the current diet options
    return violations;
  }

  function getDominantText(product, maxItems) {
    var desc = (product.description || '').replace(/<[^>]*>/g, ' ').trim();
    var parts = desc.split(/,/).map(function (s) { return s.trim(); }).filter(Boolean);
    var dominant = parts.slice(0, maxItems || 6).join(', ');
    return (product.title || '') + ' ' + dominant;
  }

  function descriptionContains(product, term) {
    var termLower = term.toLowerCase();
    var escaped = termLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(?:^|[\\s,;.!?()/])' + escaped + '(?:[\\s,;.!?()en/]|$)', 'i');
    var text = getDominantText(product, 6);
    if (re.test(text)) return true;
    if (product.tags) return product.tags.some(function (t) { return t.toLowerCase() === termLower; });
    return false;
  }

  function getDislikedIngredients(product) {
    if (!customerProfile.dislike.length) return [];
    var found = [];
    customerProfile.dislike.forEach(function (d) { if (descriptionContains(product, d)) found.push(d); });
    return found;
  }

  function getLikedIngredients(product) {
    if (!customerProfile.like.length) return [];
    var found = [];
    customerProfile.like.forEach(function (d) { if (descriptionContains(product, d)) found.push(d); });
    return found;
  }

  function sortByPreference(products, categories) {
    return products.slice().sort(function (a, b) {
      var aLikes = getLikedIngredients(a).length;
      var bLikes = getLikedIngredients(b).length;
      if (aLikes > 0 && bLikes === 0) return -1;
      if (bLikes > 0 && aLikes === 0) return 1;
      return bLikes - aLikes;
    });
  }

  // Fetch title + description + tags from Shopify for badge matching and
  // translated display. localized() keeps the locale prefix (/en, /fr), so
  // Shopify returns the Translate&Adapt content instead of the German default.
  async function loadShopifyProductData() {
    var bc = state.bundleConfig;
    if (!bc || !bc.products) return;
    var handles = [];
    bc.products.forEach(function (p) {
      if (p.handle && !handles.includes(p.handle)) handles.push(p.handle);
    });
    var batchSize = 5;
    for (var i = 0; i < handles.length; i += batchSize) {
      var batch = handles.slice(i, i + batchSize);
      var promises = batch.map(function (handle) {
        return fetch(localized('/products/' + handle + '.json'))
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (data && data.product) {
              shopifyProductData[data.product.handle] = {
                title: data.product.title || '',
                description: data.product.body_html || '',
                tags: typeof data.product.tags === 'string'
                  ? data.product.tags.split(', ').filter(Boolean)
                  : (data.product.tags || []),
              };
            }
          })
          .catch(function () {});
      });
      await Promise.all(promises);
    }
    // Cart rows render from state.selections, whose titles were snapshotted
    // from the (German) bundle config before this data arrived — build a
    // variant→title map so they can pick up the translated name too.
    bc.products.forEach(function (p) {
      var extra = shopifyProductData[p.handle] || {};
      (p.variants || []).forEach(function (v) {
        dishTitleByVid[String(v.shopifyId)] = displayDishTitle(p.title, extra.title);
      });
    });
    render();
  }

  // Enrich bundle products with Shopify data
  function enrichProduct(p) {
    var extra = shopifyProductData[p.handle] || {};
    p.description = p.description || extra.description || '';
    p.tags = p.tags || extra.tags || [];
    return p;
  }

  // ============================================================
  // SELECTIONS
  // ============================================================

  function buildSelectionsFromBundleItems(items) {
    state.selections = {};
    var bundleProducts = getBundleProducts();
    var bundleVariantSet = getBundleVariantIdSet();

    items.forEach(function (item) {
      var vid = String(item.productVariantId || item.variantId);
      if (!vid) return;

      // Skip Loop-managed addons (free gifts, one-time addons). They appear
      // in the bundle transaction items but are not part of the BYOB
      // selection — pulling them into state.selections would echo them back
      // to /bundle/transaction/update on save and break Loop's addon
      // bookkeeping (observed: duplicate update events + addon misrouting).
      if (bundleVariantSet && !bundleVariantSet[vid]) {
        try { console.log('[tt-selector] skipping non-bundle item (likely Loop addon):', vid, item.productTitle || item.title); } catch (e) {}
        return;
      }

      // Match with bundle config product for display info
      var bProd = bundleProducts.find(function (p) {
        return String(p.variantId) === vid;
      });

      state.selections[vid] = {
        quantity: item.quantity || 1,
        variantId: vid,
        productId: bProd ? bProd.id : null,
        productTitle: bProd ? bProd.title : (item.productTitle || item.title || 'Gericht'),
        variantTitle: bProd ? bProd.variantTitle : (item.variantTitle || ''),
        price: bProd ? bProd.price : parseFloat(item.price || 0),
        image: bProd ? bProd.image : (item.image ? (item.image.url || item.image) : null),
      };
    });
  }

  function isSelected(product) {
    return !!state.selections[String(product.variantId)];
  }

  function getQuantity(product) {
    var sel = state.selections[String(product.variantId)];
    return sel ? sel.quantity : 0;
  }

  function toggleProduct(product) {
    var key = String(product.variantId);
    if (state.selections[key]) {
      delete state.selections[key];
    } else {
      state.selections[key] = {
        quantity: 1,
        productTitle: product.title,
        variantTitle: product.variantTitle,
        variantId: key,
        productId: product.id,
        price: product.price,
        image: product.image,
      };
    }
    state.dirty = true;
    render();
  }

  function changeQuantity(product, delta) {
    var key = String(product.variantId);
    var sel = state.selections[key];
    if (!sel) return;

    sel.quantity = Math.max(0, sel.quantity + delta);
    if (sel.quantity === 0) {
      delete state.selections[key];
    }
    state.dirty = true;
    render();
  }

  // Check if selections contain new products not in current subscription
  function hasNewProducts() {
    var sub = state.subscription;
    var currentLines = (sub && sub.lines) || [];
    var lineVids = {};
    currentLines.forEach(function (line) {
      var vid = String(line.variantShopifyId || '');
      if (vid) lineVids[vid] = true;
    });
    var found = false;
    Object.keys(state.selections).forEach(function (vid) {
      if (!lineVids[vid]) found = true;
    });
    return found;
  }

  // Manual save only — user clicks "Speichern" button (no auto-save).

  // ============================================================
  // SAVE — Updates subscription lines directly
  // Compares current selections with existing subscription lines:
  //   - New selections → POST /subscription/{id}/line (add)
  //   - Removed items  → DELETE /subscription/{id}/line/{lineId}
  //   - Qty changes    → PUT /subscription/{id}/line/{lineId}/quantity
  // ============================================================

  // Build Loop edit URL for redirecting when adding new products
  function getLoopEditUrl() {
    var sub = state.subscription;
    if (!sub) return null;
    var contractId = sub.shopifyId || '';
    var btId = '';
    if (sub.lines && sub.lines.length) {
      for (var i = 0; i < sub.lines.length; i++) {
        if (sub.lines[i].bundleTransactionId) {
          btId = sub.lines[i].bundleTransactionId;
          break;
        }
      }
    }
    // Localize like every other in-app redirect here (COCKPIT_PATH, LOGIN_PATH,
    // etc.) — this URL carries no Langify locale segment on its own, and the
    // theme-level order-link router (layout/theme.liquid) explicitly leaves
    // "?customer=true" bundle URLs untouched (it's the intentional edit flow
    // for existing customers), so nothing else fixes it up after this.
    return localized('/a/loop_subscriptions/bundle/' + BUNDLE_NANO_ID
      + '?customer=true'
      + '&contractId=' + contractId
      + '&bundleTransactionId=' + btId
      + '&action=edit');
  }

  // If the current dish count is below every qty-tier threshold, the
  // subscription must not carry any LPBNDL discount. Loop persists a previous
  // tier's code even after a bundle update that omits discountId, so it has
  // to be removed explicitly via DELETE /subscription/{id}/discount/{gid}.
  async function cleanupStaleQuantityDiscount() {
    var sub = state.subscription;
    if (!sub || !sub.id) return;
    var totalQty = 0;
    Object.keys(state.selections).forEach(function (k) { totalQty += state.selections[k].quantity || 0; });
    if (findApplicableDiscount(totalQty)) return;
    var subDiscounts = sub.discounts || sub.appliedDiscounts || [];
    // Loop's DELETE endpoint expects the Shopify discount id (UUID string) in
    // `shopifyId`, NOT Loop's internal `id` field. Fall back through both for
    // safety in case the response shape varies by API version.
    var staleIds = subDiscounts
      .filter(function (d) { return /^LPBNDL/i.test(d.code || d.title || ''); })
      .map(function (d) { return d.shopifyId || d.id; })
      .filter(Boolean);
    for (var i = 0; i < staleIds.length; i++) {
      await apiFetch('/subscription/' + sub.id + '/discount/' + encodeURIComponent(staleIds[i]), { method: 'DELETE' });
    }
  }

  // Save via Loop's bundle transaction update endpoint.
  // Supports add/remove/qty in a single call and preserves bundle consistency
  // (discount tier + box size). Required when editing BYOB bundle subscriptions.
  async function saveViaBundleUpdate() {
    var btId = state.bundleNanoId || state.bundleTransactionId;
    if (!btId) throw new Error('Bundle-Transaktions-ID nicht gefunden.');

    // Defensive: never echo Loop-managed addons back to bundle/transaction/update
    // (see buildSelectionsFromBundleItems). state.selections should already be
    // clean, but a stale entry here would re-introduce the duplicate-update bug.
    var bundleVariantSet = getBundleVariantIdSet();
    var items = Object.keys(state.selections)
      .map(function (vid) {
        if (bundleVariantSet && !bundleVariantSet[vid]) return null;
        var sel = state.selections[vid];
        var qty = parseInt(sel.quantity, 10) || 0;
        var variantIdNum = parseInt(vid, 10);
        if (!variantIdNum || qty <= 0) return null;
        return { productVariantId: variantIdNum, quantity: qty };
      })
      .filter(Boolean);

    if (items.length === 0) throw new Error(T.selector.min_one_dish);

    var totalQty = items.reduce(function (s, it) { return s + it.quantity; }, 0);
    var boxSize = getDefaultBoxSize();
    var bt = state.bundleTransaction || {};

    // Pre-validate box size min/max so user gets a clear message instead of a Loop 422.
    if (boxSize) {
      var dw = function (n) { return T.dishUnit(n); };
      if (boxSize.minSize && totalQty < boxSize.minSize) {
        throw new Error(T.t('validation.min_dishes', {count: boxSize.minSize, unit: dw(boxSize.minSize), current: totalQty}));
      }
      if (boxSize.maxSize && totalQty > boxSize.maxSize) {
        throw new Error(T.t('validation.max_dishes', {count: boxSize.maxSize, unit: dw(boxSize.maxSize), current: totalQty}));
      }
    }

    // Loop's bundle/transaction/update API rejects calls without a discountId
    // ("Discount ID required"), even though the docs mark the field optional.
    // So we always send one — preferring the tier that matches the current
    // quantity, otherwise falling back to the lowest-quantity tier just to
    // satisfy the validator. When no tier actually applies, the LPBNDL code
    // Loop attaches gets removed post-update in cleanupStaleQuantityDiscount().
    var discount = findApplicableDiscount(totalQty);
    if (!discount) {
      var allTiers = (state.bundleConfig && state.bundleConfig.discounts) || [];
      discount = allTiers
        .filter(function (d) { return (d.purchaseType === 'SUBSCRIPTION' || d.purchaseType === 'ALL') && d.conditionType === 'QUANTITY'; })
        .sort(function (a, b) { return getDiscountMinQty(a) - getDiscountMinQty(b); })[0]
        || (bt && bt.discountId ? { id: bt.discountId } : null);
    }

    var payload = {
      id: btId,
      items: items,
    };
    if (discount && discount.id) payload.discountId = discount.id;
    var boxSizeId = bt.boxSizeId || (boxSize && boxSize.id) || null;
    if (boxSizeId) payload.boxSizeId = boxSizeId;

    console.log('POST /bundle/transaction/update payload:', JSON.stringify(payload));
    return await apiFetch('/bundle/transaction/update', { method: 'POST', body: payload });
  }

  async function saveSelections() {
    if (state.saving) return;
    state.saving = true;
    showSavingOverlay();
    render();

    try {
      var sub = state.subscription;
      if (!sub || !sub.id) throw new Error(T.selector.no_subscription);

      // Preferred path: bundle transaction update (supports add/remove/qty in one call)
      if (state.bundleNanoId) {
        await saveViaBundleUpdate();
        try {
          var refreshed = await apiFetch('/subscription/' + sub.id);
          if (refreshed) state.subscription = refreshed;
          var btRefresh = await apiFetch('/bundle/transaction/' + state.bundleNanoId);
          if (btRefresh && btRefresh.items) {
            state.bundleTransaction = btRefresh;
            // Die lokale Auswahl NICHT aus dem Refresh neu aufbauen: Loop
            // liest direkt nach dem Update teils noch den alten Stand
            // (eventual consistency) — der Rebuild liess die Box dann auf
            // die alte Gerichtzahl zurückspringen, obwohl das Update von
            // Loop akzeptiert war (Kundin 541820894, 11.06.). Was der User
            // gespeichert hat, IST der bestätigte Stand.
          }
        } catch (e) {
          console.warn('Could not refresh after bundle update:', e.message);
        }
        // Remove any stale LPBNDL discount when no qty-tier applies. Loop
        // keeps the previous tier's code on the subscription even if the
        // bundle update omits discountId, so we have to delete it explicitly.
        try { await cleanupStaleQuantityDiscount(); } catch (e) {
          console.warn('LPBNDL cleanup failed (non-fatal):', e && e.message);
        }
        state.dirty = false;
        showToast(T.selector.dishes_saved);
        state.saving = false;
        render();
        setTimeout(function () { window.location.href = COCKPIT_PATH + '?from=dishes'; }, 800);
        return;
      }

      // Legacy fallback: per-line endpoints (qty + remove only; adds not supported here)
      var subId = sub.id;
      var currentLines = sub.lines || [];
      var legacyBundleVariantSet = getBundleVariantIdSet();

      // Build maps for comparison. Skip Loop-managed addon lines (free gifts,
      // one-time addons) — they're not in state.selections by design, and we
      // must not auto-DELETE them just because they're missing on our side.
      var lineMap = {};
      currentLines.forEach(function (line) {
        var vid = String(line.variantShopifyId || '');
        if (!vid) return;
        if (legacyBundleVariantSet && !legacyBundleVariantSet[vid]) return;
        lineMap[vid] = { lineId: line.id, quantity: line.quantity || 1 };
      });

      var selMap = {};
      Object.keys(state.selections).forEach(function (key) {
        selMap[key] = state.selections[key];
      });

      // Only process qty changes and removals (new products are handled via redirect button)
      var operations = [];

      // Items to REMOVE (in current lines but not in selections)
      Object.keys(lineMap).forEach(function (vid) {
        if (!selMap[vid]) {
          operations.push({ type: 'remove', lineId: lineMap[vid].lineId, vid: vid });
        }
      });

      // Items to UPDATE quantity
      Object.keys(selMap).forEach(function (vid) {
        if (lineMap[vid] && selMap[vid].quantity !== lineMap[vid].quantity) {
          operations.push({ type: 'updateQty', lineId: lineMap[vid].lineId, quantity: selMap[vid].quantity, vid: vid });
        }
      });

      if (operations.length === 0) {
        state.dirty = false;
        showToast(T.selector.no_changes);
        state.saving = false;
        hideSavingOverlay();
        render();
        return;
      }

      console.log('Subscription line operations:', JSON.stringify(operations));

      for (var oi = 0; oi < operations.length; oi++) {
        var op = operations[oi];

        if (op.type === 'remove') {
          await apiFetch('/subscription/' + subId + '/line/' + op.lineId, { method: 'DELETE' });
          console.log('Removed line:', op.lineId, 'vid:', op.vid);

        } else if (op.type === 'updateQty') {
          await apiFetch('/subscription/' + subId + '/line/' + op.lineId + '/quantity', {
            method: 'PUT',
            body: { quantity: op.quantity },
          });
          console.log('Updated qty:', op.lineId, 'to', op.quantity);
        }
      }

      // Refresh subscription data
      try {
        var updatedSub = await apiFetch('/subscription/' + subId);
        if (updatedSub) state.subscription = updatedSub;
      } catch (e) {
        console.warn('Could not refresh subscription:', e.message);
      }

      state.dirty = false;
      showToast('Gerichte gespeichert!');
      setTimeout(function () { window.location.href = COCKPIT_PATH + '?from=dishes'; }, 800);

    } catch (err) {
      console.error('Save error:', err);
      hideSavingOverlay();
      showToast((T.common.error + ': ') + (err.message || T.selector.save_failed), true);
    } finally {
      state.saving = false;
      render();
    }
  }

  // ============================================================
  // RENDER — uses bundle config products instead of Shopify collection
  // ============================================================

  // ============================================================
  // STREAK STEPPER (5-week welcome program)
  // ============================================================

  var STREAK_STEPS = [
    { week: 1, kind: 'discount', big: '20%',         title: T.streak.welcome_discount },
    { week: 2, kind: 'discount', big: '10%',         title: T.streak.loyalty_bonus },
    { week: 3, kind: 'gift',     big: T.streak.gift, title: T.streak.surprise },
    { week: 4, kind: 'discount', big: '5%',          title: T.streak.loyalty_bonus },
    { week: 5, kind: 'gift',     big: T.streak.gift, title: T.streak.surprise }
  ];

  function getStreakWeek() {
    // QA override via URL: ?week=1..5 forces a specific welcome-program week.
    // Setting ?week=0 or ?week=off hides the banner. Stays in the URL so a
    // reload/screenshot keeps the same state.
    try {
      var override = new URLSearchParams(window.location.search).get('week');
      if (override !== null) {
        if (override === '0' || override === 'off' || override === 'none') return null;
        var n = parseInt(override, 10);
        if (!isNaN(n) && n >= 1 && n <= 5) return n;
      }
    } catch (e) {}

    // Probe several plausible Loop fields. Returns 1..5 if found, else null.
    var sub = state.subscription || {};
    var cust = state.customer || {};
    var candidates = [
      sub.streakWeek, sub.welcomeWeek,
      sub.processedOrderCount, sub.successfulOrderCount, sub.orderCount,
      cust.lifetimeOrderCount, cust.processedOrderCount, cust.orderCount
    ];
    for (var i = 0; i < candidates.length; i++) {
      var v = candidates[i];
      if (typeof v === 'number' && v >= 0) {
        // 0 processed orders → upcoming first delivery = week 1
        // 1 processed → week 2, etc.
        var wk = Math.min(5, Math.max(1, v + 1));
        return wk;
      }
    }
    return null;
  }

  function renderStreak() {
    var el = document.getElementById('tt-sel-streak');
    if (!el) return;
    var week = getStreakWeek();
    if (week == null) { el.hidden = true; el.innerHTML = ''; return; }

    var cur = STREAK_STEPS.find(function (s) { return s.week === week; }) || STREAK_STEPS[0];
    var iconGift = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
    var iconPct  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    var iconCheck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>';

    var html = '';
    html += '<div class="tt-sel-streak__inner">';
    html += '<div class="tt-sel-streak__lead">';
    html += '<span class="tt-sel-streak__eyebrow">' + esc(T.streak.program) + '</span>';
    html += '<span class="tt-sel-streak__tag">' + esc(T.t('streak.week_n', {n: week})) + ' · <b>' + esc(cur.big) + ' ' + esc(cur.title) + '</b></span>';
    html += '</div>';
    html += '<ol class="tt-sel-streak__track" aria-label="' + esc(T.selector.progress_aria) + '">';
    STREAK_STEPS.forEach(function (s, i) {
      var state;
      if (s.week < week) state = 'done';
      else if (s.week === week) state = 'current';
      else state = 'upcoming';
      var icon = state === 'done' ? iconCheck : (s.kind === 'gift' ? iconGift : iconPct);
      html += '<li class="tt-sel-streak__node is-' + state + '">';
      if (i > 0) html += '<span class="tt-sel-streak__line" aria-hidden="true"></span>';
      html += '<span class="tt-sel-streak__dot">' + icon + '</span>';
      html += '<span class="tt-sel-streak__label">';
      html += '<span class="tt-sel-streak__label-week">' + esc(T.t('streak.week_n', {n: s.week})) + '</span>';
      html += '<span class="tt-sel-streak__label-big">' + esc(s.kind === 'gift' ? T.streak.gift : s.big) + '</span>';
      html += '</span>';
      html += '</li>';
    });
    html += '</ol>';
    html += '</div>';

    el.innerHTML = html;
    el.hidden = false;
  }

  // ============================================================
  // LINE SELECTOR (top-right)
  // ============================================================

  function ttDecodeEntities(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.innerHTML = String(s);
    return d.textContent || '';
  }
  var LINE_OPTIONS = [
    { key: 'ausgewogen', label: T.line.ausgewogen, emoji: '⚖️', desc: ttDecodeEntities(T.line.ausgewogen_desc) },
    { key: 'sport',      label: T.line.sport,      emoji: '💪', desc: ttDecodeEntities(T.line.sport_desc) },
    { key: 'abnehmen',   label: T.line.abnehmen,   emoji: '🔥', desc: ttDecodeEntities(T.line.abnehmen_desc) }
  ];

  function renderLineSelector() {
    var cur = LINE_OPTIONS.find(function (o) { return o.key === state.activeFilter; }) || LINE_OPTIONS[0];
    var open = !!state.lineMenuOpen;
    var html = '';
    html += '<div class="tt-sel__line-wrap' + (open ? ' is-open' : '') + '">';
    html += '<button type="button" class="tt-sel__line-btn" data-action="toggle-line-menu" aria-expanded="' + (open ? 'true' : 'false') + '">';
    html += '<span class="tt-sel__line-eyebrow">' + esc(T.line.label) + '</span>';
    html += '<span class="tt-sel__line-current">';
    html += '<span class="tt-sel__line-emoji" aria-hidden="true">' + cur.emoji + '</span>';
    html += '<span class="tt-sel__line-label">' + esc(cur.label) + '</span>';
    html += '</span>';
    html += '<svg class="tt-sel__line-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="12" height="12"><polyline points="6 9 12 15 18 9"/></svg>';
    html += '</button>';
    if (open) {
      html += '<div class="tt-sel__line-menu" role="menu">';
      LINE_OPTIONS.forEach(function (o) {
        var active = o.key === state.activeFilter;
        html += '<button type="button" class="tt-sel__line-opt' + (active ? ' is-active' : '') + '" data-action="set-line" data-line="' + esc(o.key) + '" role="menuitemradio" aria-checked="' + (active ? 'true' : 'false') + '">';
        html += '<span class="tt-sel__line-opt-radio" aria-hidden="true"></span>';
        html += '<span class="tt-sel__line-opt-body">';
        html += '<span class="tt-sel__line-opt-title"><span aria-hidden="true">' + o.emoji + '</span> ' + esc(o.label) + '</span>';
        html += '<span class="tt-sel__line-opt-desc">' + esc(o.desc) + '</span>';
        html += '</span>';
        html += '</button>';
      });
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function setLine(line) {
    if (!line) { state.lineMenuOpen = false; render(); return; }
    if (state.activeFilter !== line) {
      state.activeFilter = line;
      try { localStore.setItem('tt_selector_line', line); } catch (e) {}
    }
    state.lineMenuOpen = false;
    render();
  }

  // ============================================================
  // DELIVERY TIMELINE (Jetzt → Bestellschluss → Lieferung)
  // ============================================================

  function fmtNowLabel() {
    var now = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    return ttDayShort(now) + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
  }
  function fmtDateShort(d) {
    if (!(d instanceof Date) || isNaN(d)) return '';
    return d.toLocaleDateString(TT_LOCALE, { day: '2-digit', month: '2-digit' });
  }
  function fmtWeekdayTime(d, time) {
    if (!(d instanceof Date) || isNaN(d)) return '';
    return ttDayShort(d) + ' ' + (time || '');
  }

  function startNowTicker() {
    if (state._nowTickerBound) return;
    state._nowTickerBound = true;
    var tick = function () {
      var el = document.getElementById('tt-sel-now');
      if (el) el.textContent = fmtNowLabel();
    };
    var msToNextMin = 60000 - (Date.now() % 60000);
    setTimeout(function () {
      tick();
      setInterval(tick, 60000);
    }, msToNextMin);
  }

  // ============================================================
  // CATEGORY TAB BAR
  // ============================================================

  function categorySlug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }

  function renderCategoryTabs(visibleCats) {
    if (!visibleCats || !visibleCats.length) return '';
    var active = state.activeCategoryId || visibleCats[0].id;
    // Linien-Selector zuerst (float:right) → er sitzt oben rechts auf Höhe
    // der ersten Kategorie, die Tabs umfließen ihn (volle Breite ab Zeile 2).
    var html = '<div class="tt-sel__tabs-row">';
    html += renderLineSelector();
    html += '<div class="tt-sel__tabs" role="tablist">';
    visibleCats.forEach(function (c) {
      var slug = 'tt-sel-cat-' + categorySlug(c.title);
      var isActive = c.id === active;
      html += '<button type="button" role="tab" aria-selected="' + (isActive ? 'true' : 'false') + '" class="tt-sel__tab' + (isActive ? ' is-active' : '') + '" data-action="scroll-cat" data-target="' + esc(slug) + '">';
      html += '<span class="tt-sel__tab-label">' + esc(displayCategoryTitle(c.title)) + '</span>';
      html += '<span class="tt-sel__tab-count">' + c.count + '</span>';
      html += '</button>';
    });
    html += '</div>';
    html += '</div>';
    return html;
  }

  // ============================================================
  // STICKY BOTTOM CART BAR
  // ============================================================

  function renderCartBar() {
    var bar = document.getElementById('tt-sel-cartbar');
    var backdrop = document.getElementById('tt-sel-cart-backdrop');
    if (!bar) return;

    var cartKeys = Object.keys(state.selections);
    var subtotal = 0;
    var totalQty = 0;
    cartKeys.forEach(function (k) {
      var s = state.selections[k];
      totalQty += s.quantity || 0;
      subtotal += (s.price || 0) * (s.quantity || 0);
    });

    if (totalQty === 0) {
      // Kein Gericht ausgewählt → gar keine Cartbar zeigen (früher: leerer
      // "Warenkorb ist leer"-Banner). Der Balken erscheint erst, sobald das
      // erste Gericht in der Box liegt.
      bar.hidden = true;
      bar.classList.remove('is-open');
      bar.classList.remove('is-empty');
      bar.innerHTML = '';
      if (backdrop) backdrop.hidden = true;
      return;
    }

    bar.classList.remove('is-empty');
    var tiers = getDiscountTiers();
    var maxQty = tiers.length ? tiers[tiers.length - 1].qty : Math.max(totalQty, 14);
    var currentTier = null;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (totalQty >= tiers[i].qty) { currentTier = tiers[i]; break; }
    }
    var nextTier = tiers.find(function (t) { return totalQty < t.qty; }) || null;

    // Combine the bundle's quantity tier (auto, recalculated at save) with any
    // customer-applied coupons on the subscription (TTInnerCircle..., etc.).
    // LPBNDL* codes are managed by Loop and replaced by the qty tier on save,
    // so we ignore them here to avoid double-counting.
    var subDiscounts = (state.subscription && state.subscription.discounts) || [];
    var discountLines = [];
    var totalDiscount = 0;

    if (currentTier && currentTier.pct > 0) {
      var amt = subtotal * (currentTier.pct / 100);
      discountLines.push({
        label: T.t('cart.quantity_discount', {count: totalQty, percent: currentTier.pct}),
        code: null,
        amt: amt
      });
      totalDiscount += amt;
    }

    var afterTier = subtotal - (currentTier ? subtotal * (currentTier.pct / 100) : 0);
    subDiscounts.forEach(function (d) {
      var code = d.code || d.title || '';
      if (/^LPBNDL/i.test(code)) return;
      var pct = (d.value && d.value.percentage) ? parseFloat(d.value.percentage) : 0;
      var fixed = (d.value && d.value.fixedAmount) ? parseFloat(d.value.fixedAmount) : 0;
      var amt = pct ? afterTier * (pct / 100) : fixed;
      if (amt <= 0.001) return;
      var label = pct ? (code + ' · −' + pct + '%') : code;
      discountLines.push({ label: label, code: code, amt: amt });
      totalDiscount += amt;
      afterTier -= amt;
    });

    var total = subtotal - totalDiscount;
    var totalPctOff = subtotal > 0 ? Math.round((totalDiscount / subtotal) * 100) : 0;
    var progressPct = Math.min(100, (totalQty / maxQty) * 100);
    var isOpen = !!state.cartOpen;

    var html = '';

    // Expanded panel (above the bar)
    html += '<div class="tt-sel-cartbar__panel" aria-hidden="' + (isOpen ? 'false' : 'true') + '">';
    html += '<div class="tt-sel-cartbar__panel-head">';
    html += '<h3>' + esc(T.cart.panel_title) + '<span class="tt-sel-cartbar__panel-count"> · ' + totalQty + ' ' + esc(T.dishUnit(totalQty)) + '</span></h3>';
    html += '<button type="button" class="tt-sel-cartbar__close" data-action="close-cart" aria-label="' + esc(T.common.close) + '"><span class="tt-sel-cartbar__close-label">' + esc(T.common.close) + '</span><span aria-hidden="true">✕</span></button>';
    html += '</div>';
    html += '<div class="tt-sel-cartbar__list">';
    cartKeys.forEach(function (k) {
      var sel = state.selections[k];
      var rowName = dishTitleByVid[k] || sel.productTitle || T.common.dish_one;
      html += '<div class="tt-sel-cartbar__row">';
      if (sel.image) {
        html += '<img class="tt-sel-cartbar__row-img" src="' + esc(sel.image) + '" alt="' + esc(rowName) + '">';
      } else {
        html += '<div class="tt-sel-cartbar__row-img tt-sel-cartbar__row-img--empty"></div>';
      }
      html += '<div class="tt-sel-cartbar__row-body">';
      html += '<div class="tt-sel-cartbar__row-name">' + esc(rowName) + '</div>';
      // Per-item prices removed — only the summary (Zwischensumme / Rabatte /
      // Total) shows pricing now.
      html += '</div>';
      html += '<div class="tt-sel__cart-qty tt-sel-cartbar__row-qty">';
      html += '<button class="tt-sel__qty-btn" data-action="qty-minus" data-vid="' + esc(k) + '">−</button>';
      html += '<span class="tt-sel__qty-val">' + sel.quantity + '</span>';
      html += '<button class="tt-sel__qty-btn" data-action="qty-plus" data-vid="' + esc(k) + '">+</button>';
      html += '</div>';
      html += '<button type="button" class="tt-sel-cartbar__row-del" data-action="cart-remove" data-vid="' + esc(k) + '" aria-label="' + esc(T.selector.remove) + '">';
      html += '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';
      html += '</button>';
      html += '</div>';
    });
    html += '</div>';
    html += '<div class="tt-sel-cartbar__summary">';
    html += '<div class="tt-sel-cartbar__summary-row"><span>' + esc(T.cart.subtotal) + '</span><span>CHF ' + subtotal.toFixed(2) + '</span></div>';
    discountLines.forEach(function (line) {
      html += '<div class="tt-sel-cartbar__summary-row tt-sel-cartbar__summary-discount"><span>' + esc(line.label) + '</span><span>−CHF ' + line.amt.toFixed(2) + '</span></div>';
    });
    html += '<div class="tt-sel-cartbar__summary-row tt-sel-cartbar__summary-total"><span>' + esc(T.cart.total) + '</span><span>CHF ' + total.toFixed(2) + '</span></div>';
    html += '<div class="tt-sel-cartbar__hint">';
    if (nextTier) {
      var needed = nextTier.qty - totalQty;
      html += T.t('cart.tip_more_html', {count: needed, unit: T.dishUnit(needed), percent: nextTier.pct});
    } else {
      html += T.cart.tip_max;
    }
    html += '</div>';
    html += '</div>';
    html += '</div>';

    // Inner bar (always visible)
    html += '<div class="tt-sel-cartbar__inner" data-action="toggle-cart" role="button" tabindex="0" aria-expanded="' + (isOpen ? 'true' : 'false') + '">';
    html += '<div class="tt-sel-cartbar__sum">';
    html += '<span class="tt-sel-cartbar__badge">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    html += '<span class="tt-sel-cartbar__qty">' + totalQty + '</span>';
    html += '</span>';
    html += '<span class="tt-sel-cartbar__info">';
    html += '<span class="tt-sel-cartbar__open">';
    html += (isOpen ? T.cart.close : T.cart.open);
    html += '<svg class="tt-sel-cartbar__open-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="11" height="11" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
    html += '</span>';
    html += '<span class="tt-sel-cartbar__sub">';
    if (nextTier) {
      var nMissing = nextTier.qty - totalQty;
      html += T.t('cart.still_for', {count: nMissing, percent: nextTier.pct}).replace(/\b(\d+)\b/, '<b>$1</b>').replace(/−(\d+%)/, '<b>−$1</b>');
    } else if (currentTier) {
      html += '<b>' + esc(T.cart.max_discount) + '</b>';
    } else {
      html += T.cart.choose_dishes;
    }
    html += '</span>';
    html += '</span>';
    html += '</div>';

    html += '<div class="tt-sel-cartbar__progress">';
    html += '<div class="tt-sel-cartbar__track">';
    html += '<div class="tt-sel-cartbar__fill" style="width:' + progressPct + '%"></div>';
    tiers.forEach(function (t) {
      var left = Math.min(100, (t.qty / maxQty) * 100);
      var reached = totalQty >= t.qty;
      html += '<div class="tt-sel-cartbar__tier' + (reached ? ' is-reached' : '') + '" style="left:' + left + '%">';
      html += '<span class="tt-sel-cartbar__tier-dot"></span>';
      html += '<span class="tt-sel-cartbar__tier-label">' + t.qty + '</span>';
      html += '</div>';
    });
    html += '</div>';
    html += '</div>';

    html += '<div class="tt-sel-cartbar__right" data-cart-stop>';
    html += '<div class="tt-sel-cartbar__total">';
    if (totalDiscount > 0.01) html += '<s>CHF ' + subtotal.toFixed(2) + '</s>';
    html += '<b>CHF ' + total.toFixed(2) + '</b>';
    html += '</div>';
    var saveDisabled = !state.dirty || state.saving;
    var saveLabel = state.saving ? T.selector.saving : (state.dirty ? T.selector.save_label : T.selector.saved);
    var canSaveViaApi = !!state.bundleNanoId || !hasNewProducts();
    if (canSaveViaApi) {
      // While saving, swap the arrow for a spinner and keep the button fully
      // opaque (via .is-saving) so the customer clearly sees it's working.
      var saveIcon = state.saving
        ? '<span class="tt-sel-cartbar__cta-spinner" aria-hidden="true"></span>'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
      html += '<button type="button" class="tt-sel-cartbar__cta' + (state.saving ? ' is-saving' : '') + '" id="tt-sel-save-btn" data-action="save"' + (saveDisabled ? ' disabled' : '') + '>'
        + esc(saveLabel)
        + saveIcon
        + '</button>';
    } else {
      html += '<button type="button" class="tt-sel-cartbar__cta" id="tt-sel-redirect-btn" data-action="save-redirect">' + esc(T.selector.apply_btn) + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></button>';
    }
    html += '</div>';
    html += '</div>';

    bar.innerHTML = html;
    bar.hidden = false;
    bar.classList.toggle('is-open', isOpen);
    if (backdrop) {
      backdrop.hidden = !isOpen;
      backdrop.onclick = function () { state.cartOpen = false; renderCartBar(); };
    }
    if (window.TTHistory) {
      if (isOpen) window.TTHistory.open('cart', closeCart);
      else window.TTHistory.close('cart');
    }
  }

  function toggleCart() {
    state.cartOpen = !state.cartOpen;
    renderCartBar();
  }
  function closeCart() {
    state.cartOpen = false;
    renderCartBar();
  }

  function scrollSpyCategories() {
    if (state._scrollSpyBound) return;
    state._scrollSpyBound = true;
    var raf = false;
    var update = function () {
      var tabs = Array.from(document.querySelectorAll('.tt-sel__tab[data-target]'));
      if (!tabs.length) return;
      var anchorY = 120;
      var best = tabs[0].dataset.target;
      tabs.forEach(function (t) {
        var sec = document.getElementById(t.dataset.target);
        if (!sec) return;
        if (sec.getBoundingClientRect().top - anchorY < 0) best = t.dataset.target;
      });
      tabs.forEach(function (t) {
        var on = t.dataset.target === best;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
    };
    window.addEventListener('scroll', function () {
      if (raf) return; raf = true;
      requestAnimationFrame(function () { update(); raf = false; });
    }, { passive: true });
    update();
  }

  function render() {
    var sub = state.subscription;
    var bundleProducts = getBundleProducts();
    var categories = getCategories();
    var html = '';

    // ── Back Link ──
    html += '<a href="' + esc(COCKPIT_PATH) + '" class="tt-sel__back">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
    html += T.common.back_to_cockpit;
    html += '</a>';

    // ── Title row with timeline on the right ──
    var sched = sub && sub.nextBillingDate ? getDeadlineAndDelivery(sub.nextBillingDate) : { deadline: null, delivery: null };
    if (sched.delivery) {
      var wk = isoWeekNumber(sched.delivery);
      document.title = T.t('selector.page_title', {week: wk});
    }
    html += '<div class="tt-sel__head-row">';
    html += '<div class="tt-sel__head-left">';
    html += '<h1 class="tt-sel__title">' + esc(T.selector.title) + '</h1>';
    if (sched.delivery) {
      var leadDeliveryShort = fmtDayLong(sched.delivery).replace(/, \d{4}.*$/, '').replace(/\bMittwoch\b/, 'Mi') ;
      // Build short Mi 29.04. style
      var dShort = ttDayShort(sched.delivery) + ', ' + sched.delivery.toLocaleDateString(TT_LOCALE, { day: '2-digit', month: '2-digit' });
      var cShort = ttDayShort(sched.deadline) + 'tag ' + sched.deadline.toLocaleDateString(TT_LOCALE, { day: '2-digit', month: '2-digit' }).replace(/\.$/, '');
      html += '<p class="tt-sel__lead">';
      html += T.t('selector.lead_returning_html', {date: dShort});
      html += '</p>';
    }
    // Box-size hint: only show when there's a meaningful constraint. Loop's
    // default RANGE_BUNDLE returns minSize=1/maxSize=0 which isn't worth
    // surfacing. Also handles singular/plural correctly.
    var boxSize = getDefaultBoxSize();
    var minS = boxSize && boxSize.minSize > 1 ? boxSize.minSize : 0;
    var maxS = boxSize && boxSize.maxSize > 0 ? boxSize.maxSize : 0;
    var dishWord = function (n) { return T.dishUnit(n); };
    if (minS || maxS) {
      var sizeInfo = '';
      if (minS && maxS) {
        sizeInfo = T.t('selector.size_range', {min: minS, max: maxS, unit: dishWord(maxS)});
      } else if (minS) {
        sizeInfo = T.t('selector.size_min', {min: minS, unit: dishWord(minS)});
      } else if (maxS) {
        sizeInfo = T.t('selector.size_max', {max: maxS, unit: dishWord(maxS)});
      }
      if (sizeInfo) {
        html += '<p class="tt-sel__subtitle">' + esc(sizeInfo) + '</p>';
      }
    }
    html += '</div>';
    html += '</div>';

    // ── Enrich all products with Shopify data (used for diet icons) ──
    bundleProducts.forEach(enrichProduct);

    // ── Resolve category sections + counts so tabs + content stay in sync ──
    var sections = [];
    categories.forEach(function (cat) {
      var catProducts = bundleProducts.filter(function (p) { return p.categoryId === cat.id; });
      if (catProducts.length === 0) return;
      var always = isAlwaysVisibleCategory(cat.title);
      var filtered = always ? catProducts : filterProducts(catProducts, categories);
      if (filtered.length === 0) return;
      sections.push({ id: cat.id, title: cat.title, subTitle: cat.subTitle, products: filtered, slug: 'tt-sel-cat-' + categorySlug(cat.title), count: filtered.length });
    });
    var uncategorized = bundleProducts.filter(function (p) { return !p.categoryId; });
    if (uncategorized.length > 0) {
      sections.push({ id: '__uncat__', title: 'Weitere Gerichte', subTitle: null, products: uncategorized, slug: 'tt-sel-cat-weitere', count: uncategorized.length });
    }

    // ── Category tab row + line selector ──
    html += renderCategoryTabs(sections);

    // ── Render sections ──
    // The FIRST section title row carries a second line-selector instance:
    // CSS shows it on mobile only (the tabs-row instance hides there), so the
    // pill sits next to "Fleisch & Fisch" instead of colliding with the tabs.
    sections.forEach(function (sec, idx) {
      html += '<section class="tt-sel__cat" id="' + esc(sec.slug) + '">';
      if (idx === 0) {
        html += '<div class="tt-sel__section-head">';
        html += '<div class="tt-sel__section-title">' + esc(displayCategoryTitle(sec.title)) + '</div>';
        html += '<div class="tt-sel__section-line">' + renderLineSelector() + '</div>';
        html += '</div>';
      } else {
        html += '<div class="tt-sel__section-title">' + esc(displayCategoryTitle(sec.title)) + '</div>';
      }
      if (sec.subTitle) html += '<p class="tt-sel__subtitle">' + esc(displayCategorySubtitle(sec.title, sec.subTitle)) + '</p>';
      if (T.abo && T.abo.breakfast_note && isBreakfastCategory(sec.title)) {
        html += '<p class="tt-sel__subtitle">' + esc(ttDecodeEntities(T.abo.breakfast_note)) + '</p>';
      }
      html += renderProductGrid(sec.products, false, false);
      html += '</section>';
    });

    elContent.innerHTML = html;
    bindEvents();
    renderStreak();
    renderCartBar();
    startNowTicker();
    scrollSpyCategories();
  }

  function renderProductGrid(products, showPrefs, checkDietViolations) {
    var cats = getCategories();
    var html = '<div class="tt-sel__grid">';
    var discountFactor = getCurrentDiscountFactor();

    products.forEach(function (product) {
      var selected = isSelected(product);
      var qty = getQuantity(product);
      var price = parseFloat(product.price || 0);
      var hasDiscount = discountFactor < 0.999;
      var effective = price * discountFactor;
      var vid = String(product.variantId);
      var liked = showPrefs ? getLikedIngredients(product) : [];
      var disliked = showPrefs ? getDislikedIngredients(product) : [];
      var violations = checkDietViolations ? getDietViolations(product, cats) : [];
      var isMuted = violations.length > 0;

      html += '<div class="tt-sel__card' + (selected ? ' tt-sel__card--selected' : '') + (liked.length ? ' tt-sel__card--liked' : '') + (isMuted ? ' tt-sel__card--muted' : '') + '" data-action="toggle" data-vid="' + esc(vid) + '">';
      html += '<div class="tt-sel__check">\u2713</div>';

      if (disliked.length) {
        html += '<div class="tt-sel__disliked-badge">' + esc(disliked.join(', ')) + '</div>';
      } else if (liked.length) {
        html += '<div class="tt-sel__liked-badge">' + esc(liked.join(', ')) + '</div>';
      }

      if (product.image) {
        html += '<img class="tt-sel__card-img" src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy" data-action="detail" data-vid="' + esc(vid) + '">';
      } else {
        html += '<div class="tt-sel__card-img--empty" data-action="detail" data-vid="' + esc(vid) + '"></div>';
      }

      html += '<div class="tt-sel__card-body">';
      html += '<div class="tt-sel__card-name">' + esc(product.title) + '</div>';
      if (product.variantTitle && product.variantTitle !== 'Default Title') {
        html += '<div class="tt-sel__card-variant">' + esc(product.variantTitle) + '</div>';
      }
      var nutri = parseNutrition(product.shortDescription) || parseNutrition(product.description);
      if (nutri) {
        html += renderNutritionChips(nutri, { compact: true });
      } else if (product.shortDescription) {
        var cleanShort = product.shortDescription.replace(/<[^>]*>/g, '').trim();
        if (cleanShort) {
          html += '<div class="tt-sel__card-nutrition">' + esc(cleanShort) + '</div>';
        }
      }
      if (price > 0) {
        if (hasDiscount) {
          html += '<div class="tt-sel__card-price tt-sel__card-price--discounted">';
          html += '<s>CHF ' + price.toFixed(2) + '</s>';
          html += '<strong>CHF ' + effective.toFixed(2) + '</strong>';
          html += '</div>';
        } else {
          html += '<div class="tt-sel__card-price">CHF ' + price.toFixed(2) + '</div>';
        }
      }

      html += '<button class="tt-sel__add-btn" data-action="toggle" data-vid="' + esc(vid) + '">' + esc(T.selector.modal_add) + '</button>';

      html += '<div class="tt-sel__qty">';
      html += '<button class="tt-sel__qty-btn" data-action="qty-minus" data-vid="' + esc(vid) + '">\u2212</button>';
      html += '<span class="tt-sel__qty-val">' + qty + '</span>';
      html += '<button class="tt-sel__qty-btn" data-action="qty-plus" data-vid="' + esc(vid) + '">+</button>';
      html += '</div>';

      html += '</div>';
      html += '</div>';
    });

    html += '</div>';
    return html;
  }

  // ============================================================
  // EVENTS
  // ============================================================

  function findProduct(vid) {
    var sVid = String(vid);
    var bundleProducts = getBundleProducts();

    var found = bundleProducts.find(function (p) {
      return String(p.variantId) === sVid;
    });
    if (found) { enrichProduct(found); return found; }

    // Fallback: from current selections
    var sel = state.selections[sVid];
    if (sel) {
      return {
        id: sel.productId || vid,
        variantId: sel.variantId || vid,
        title: sel.productTitle || 'Gericht',
        variantTitle: sel.variantTitle,
        price: sel.price || 0,
        image: sel.image,
      };
    }
    return null;
  }

  function bindCartBarOnce() {
    if (state._cartBarBound) return;
    state._cartBarBound = true;
    var bar = document.getElementById('tt-sel-cartbar');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;
      var action = target.getAttribute('data-action');
      // Click on right-side (total + CTA) should not toggle the panel
      var stop = e.target.closest('[data-cart-stop]');
      if (action === 'toggle-cart') {
        if (stop) return;
        toggleCart();
        return;
      }
      if (action === 'close-cart') {
        e.stopPropagation();
        closeCart();
        return;
      }
      if (action === 'qty-minus' || action === 'qty-plus') {
        e.stopPropagation();
        var vid = target.getAttribute('data-vid');
        var product = findProduct(vid);
        if (product) changeQuantity(product, action === 'qty-plus' ? 1 : -1);
        return;
      }
      if (action === 'cart-remove') {
        e.stopPropagation();
        var rvid = target.getAttribute('data-vid');
        delete state.selections[rvid];
        state.dirty = true;
        render();
        return;
      }
      if (action === 'save') {
        e.stopPropagation();
        if (!state.dirty || state.saving) return;
        saveSelections();
        return;
      }
      if (action === 'save-redirect') {
        e.stopPropagation();
        var editUrl = getLoopEditUrl();
        if (editUrl) window.location.href = editUrl;
        return;
      }
    });
    bar.addEventListener('keydown', function (e) {
      var t = e.target.closest('[data-action="toggle-cart"]');
      if (t && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        toggleCart();
      }
    });

    // Auto-open the cart panel once the user has scrolled most of the way
    // through the page. Only fires once per page load and only when the
    // cart isn't empty / hasn't been opened manually yet.
    var autoOpened = false;
    var manuallyTouched = false;
    bar.addEventListener('click', function () { manuallyTouched = true; }, true);
    window.addEventListener('scroll', function () {
      if (autoOpened || manuallyTouched) return;
      if (state.cartOpen) { autoOpened = true; return; }
      if (!Object.keys(state.selections).length) return;
      var doc = document.documentElement;
      var pct = (window.scrollY + window.innerHeight) / doc.scrollHeight;
      if (pct >= 0.75) {
        autoOpened = true;
        state.cartOpen = true;
        renderCartBar();
      }
    }, { passive: true });
  }

  function bindEvents() {
    // Bind the persistent cart bar listeners exactly once.
    bindCartBarOnce();

    // Close line-selector menu on outside click / Esc.
    if (!state._lineMenuOutsideBound) {
      document.addEventListener('click', function (e) {
        if (!state.lineMenuOpen) return;
        if (e.target.closest('.tt-sel__line-wrap')) return;
        state.lineMenuOpen = false;
        render();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && state.lineMenuOpen) {
          state.lineMenuOpen = false;
          render();
        }
      });
      state._lineMenuOutsideBound = true;
    }

    // Save + redirect are now handled by bindCartBarOnce() since the buttons
    // live inside the persistent #tt-sel-cartbar element.

    elContent.onclick = function (e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.getAttribute('data-action');

      // Category tab — scroll to section
      if (action === 'scroll-cat') {
        e.preventDefault();
        var sec = document.getElementById(target.getAttribute('data-target'));
        if (sec) {
          var top = sec.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        return;
      }

      // Line selector menu — toggle / pick
      if (action === 'toggle-line-menu') {
        e.preventDefault();
        state.lineMenuOpen = !state.lineMenuOpen;
        render();
        return;
      }
      if (action === 'set-line') {
        e.preventDefault();
        setLine(target.getAttribute('data-line'));
        return;
      }

      // Toggle not-recommended section
      if (action === 'toggle-nr') {
        e.preventDefault();
        var body = elContent.querySelector('.tt-sel__nr-body');
        var chevron = elContent.querySelector('.tt-sel__nr-chevron');
        if (body) {
          var open = body.style.display !== 'none';
          body.style.display = open ? 'none' : '';
          if (chevron) chevron.textContent = open ? '\u25B2' : '\u25BC';
        }
        return;
      }

      var vid = target.getAttribute('data-vid');
      var product = findProduct(vid);
      if (!product) return;

      e.preventDefault();
      e.stopPropagation();

      if (action === 'detail') {
        openDetail(product);
      } else if (action === 'toggle') {
        toggleProduct(product);
      } else if (action === 'qty-minus') {
        changeQuantity(product, -1);
      } else if (action === 'qty-plus') {
        changeQuantity(product, 1);
      }
    };
  }

  // ============================================================
  // DETAIL MODAL
  // ============================================================

  var elModal = document.getElementById('tt-sel-modal');
  var elModalContent = document.getElementById('tt-sel-modal-body');

  function openDetail(product) {
    var selected = isSelected(product);
    var qty = getQuantity(product);
    var price = parseFloat(product.price || 0);

    var html = '';
    html += '<button class="tt-sel__modal-close" id="tt-sel-modal-close">&times;</button>';

    if (product.image) {
      html += '<img class="tt-sel__modal-img" src="' + esc(product.image) + '" alt="' + esc(product.title) + '">';
    }

    html += '<div class="tt-sel__modal-info">';
    html += '<h2 class="tt-sel__modal-title">' + esc(product.title) + '</h2>';
    if (product.variantTitle && product.variantTitle !== 'Default Title') {
      html += '<div class="tt-sel__modal-variant">' + esc(product.variantTitle) + '</div>';
    }
    if (price > 0) {
      var df = getCurrentDiscountFactor();
      if (df < 0.999) {
        html += '<div class="tt-sel__modal-price tt-sel__card-price--discounted">';
        html += '<s>CHF ' + price.toFixed(2) + '</s>';
        html += '<strong>CHF ' + (price * df).toFixed(2) + '</strong>';
        html += '</div>';
      } else {
        html += '<div class="tt-sel__modal-price">CHF ' + price.toFixed(2) + '</div>';
      }
    }
    var modalNutri = parseNutrition(product.shortDescription) || parseNutrition(product.description);
    if (modalNutri) {
      html += renderNutritionChips(modalNutri);
    }
    // Description: render all labelled sections (intro + Nährwertangaben +
    // Zutaten + Hinweis + Allergene). Portion is skipped because it's a single
    // value shown elsewhere; Nährwertangaben stays because the chips only
    // capture kcal/prot/carb/fett — the text often has more (Salz, kJ, Zucker).
    if (product.description) {
      var fullPlain = String(product.description)
        .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/[ \t]+/g, ' ')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/\n{2,}/g, '\n')
        .trim();

      // Section labels in all three storefront languages — the description
      // arrives locale-aware (DE/EN/FR) from /products/<handle>.json.
      var labelRe = /\b(Portion|N[äa]hrwertangaben|N[äa]hrwerte|Nutritional information|Informations? nutritionnelles?|Valeurs? nutritionnelles?|Valeurs? nutritives?|Zutaten|Ingredients|Ingr[ée]dients|Hinweis(?:e)?|Notes?|Remarques?|Allergene|Allerg[èe]nes|Allergens?)\s*:?/gi;
      var sections = [];
      var lastIdx = 0;
      var lastLabel = null;
      var m;
      while ((m = labelRe.exec(fullPlain)) !== null) {
        sections.push({ label: lastLabel, text: fullPlain.slice(lastIdx, m.index).trim() });
        lastLabel = m[1];
        lastIdx = m.index + m[0].length;
      }
      sections.push({ label: lastLabel, text: fullPlain.slice(lastIdx).trim() });

      var skipLabel = /^portion$/i;
      sections.forEach(function (sec) {
        if (!sec.text) return;
        if (!sec.label) {
          html += '<p class="tt-sel__modal-desc">' + esc(sec.text).replace(/\n/g, '<br>') + '</p>';
        } else if (!skipLabel.test(sec.label)) {
          html += '<h4 class="tt-sel__modal-section-title">' + esc(sec.label) + '</h4>';
          html += '<p class="tt-sel__modal-zutaten">' + esc(sec.text).replace(/\n/g, '<br>') + '</p>';
        }
      });
    }

    if (selected) {
      html += '<div class="tt-sel__modal-actions">';
      html += '<div class="tt-sel__modal-qty">';
      html += '<button class="tt-sel__qty-btn" id="tt-sel-mdl-minus">−</button>';
      html += '<span class="tt-sel__qty-val">' + qty + '</span>';
      html += '<button class="tt-sel__qty-btn" id="tt-sel-mdl-plus">+</button>';
      html += '</div>';
      html += '<button class="tt-sel__modal-remove" id="tt-sel-mdl-remove">' + esc(T.selector.remove) + '</button>';
      html += '</div>';
    } else {
      html += '<button class="tt-sel__save-btn" id="tt-sel-mdl-add" style="width:100%;margin-top:20px">' + esc(T.selector.modal_add) + '</button>';
    }

    html += '</div>';

    elModalContent.innerHTML = html;
    elModal.classList.add('tt-sel__modal--open');
    document.body.style.overflow = 'hidden';
    if (window.TTHistory) window.TTHistory.open('detail', closeDetail);

    document.getElementById('tt-sel-modal-close').onclick = closeDetail;
    elModal.onclick = function (e) {
      if (e.target === elModal) closeDetail();
    };

    var addBtn = document.getElementById('tt-sel-mdl-add');
    if (addBtn) {
      addBtn.onclick = function () {
        toggleProduct(product);
        closeDetail();
      };
    }

    var removeBtn = document.getElementById('tt-sel-mdl-remove');
    if (removeBtn) {
      removeBtn.onclick = function () {
        delete state.selections[String(product.variantId)];
        state.dirty = true;
        closeDetail();
        render();
      };
    }

    var minusBtn = document.getElementById('tt-sel-mdl-minus');
    var plusBtn = document.getElementById('tt-sel-mdl-plus');
    if (minusBtn) {
      minusBtn.onclick = function () {
        changeQuantity(product, -1);
        openDetail(product);
      };
    }
    if (plusBtn) {
      plusBtn.onclick = function () {
        changeQuantity(product, 1);
        openDetail(product);
      };
    }
  }

  function closeDetail() {
    elModal.classList.remove('tt-sel__modal--open');
    document.body.style.overflow = '';
    if (window.TTHistory) window.TTHistory.close('detail');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && elModal.classList.contains('tt-sel__modal--open')) {
      closeDetail();
    }
  });

  // ============================================================
  // START
  // ============================================================

  // bfcache guard: tapping Back from the cockpit restores this page from
  // the back/forward cache with the frozen saving state — the dim backdrop
  // would stay up and block the whole page. Reset on restore.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    state.saving = false;
    hideSavingOverlay();
    try { render(); } catch (err) { /* restored before first render */ }
  });

  init();

})();
